/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime.js';
import type {
  ActiveCustomerIdResponse,
  AddScriptStepFieldRequest,
  AddScriptStepSentenceRequest,
  AddTeamUserRequest,
  AnalyticsSummaryEntity,
  AssignCustomerToContactRequest,
  CallControlsConfig,
  CloneScorecardTemplateRequest,
  CloseContactRequest,
  Contact,
  ContactEventEntity,
  ContactSortBy,
  ContactSummary,
  ContactsTimeInterval,
  CreateApiKeyRequest,
  CreateApiKeyResponse,
  CreateCommandExecutionRequest,
  CreateContactEntryRequest,
  CreateContactEntryResponse,
  CreateContactEventRequest,
  CreateContactScriptManifestRequest,
  CreateContactScriptResponse,
  CreateCrmIntegrationRequest,
  CreateCustomerNoteRequest,
  CreateCustomerRequest,
  CreateExternalServiceRequest,
  CreateExtractorRequest,
  CreateFieldRequest,
  CreateGeneratorRequest,
  CreateHookRequest,
  CreateLiveAssistDemoRequest,
  CreateLiveAssistDemoResponse,
  CreateManualQARequest,
  CreateOrUpdateScriptStepStatusRequest,
  CreateRuleRequest,
  CreateScorecardRequest,
  CreateScorecardResponse,
  CreateScorecardTemplateRequest,
  CreateScriptRequest,
  CreateScriptSectionRequest,
  CreateScriptStepRequest,
  CreateSearchRequest,
  CreateSearchResponse,
  CreateSectionRequest,
  CreateSentenceRequest,
  CreateSuggestionRequest,
  CreateSuggestionResponse,
  CreateTaskFromSuggestionRequest,
  CreateTaskRequest,
  CreateTeamRequest,
  CreateTeamResponse,
  CreateUserRequest,
  CreateUserResponse,
  CrmIntegrationResponse,
  CrmIntegrationTestCreateCustomerResponse,
  CrmIntegrationsResponse,
  CustomerDetails,
  CustomerStatus,
  CustomersListResponse,
  ExternalServiceResponse,
  ExternalServicesResponse,
  ExtractSentenceRequest,
  ExtractionResponse,
  FeedbackSortBy,
  Field,
  FieldsResponse,
  GetAllScorecardFeedbacksResponse,
  GetApiKeysResponse,
  GetContactFieldsResponse,
  GetContactScriptResponse,
  GetContactScriptsResponse,
  GetContactTranscriptSummaryResponse,
  GetContactsResponse,
  GetContactsStatsResponse,
  GetContactsTimeseriesResponse,
  GetCustomerPreviewResponse,
  GetDemoConvSignedUrlResponse,
  GetOrderResponse,
  GetOrdersResponse,
  GetProductListPreviewResponse,
  GetReviewerScorecardStatsResponse,
  GetScorecardFeedbacksResponse,
  GetScorecardResponse,
  GetScorecardResultResponse,
  GetScriptLogsResponse,
  GetTeamResponse,
  GetTeamUsersResponse,
  GetTeamsResponse,
  GetTenantContactEventsResponse,
  GetTenantsResponse,
  GetUserResponse,
  GetUsersResponse,
  Guidance,
  LeaderboardEntryEntity,
  ListAgentsResponse,
  ListHooksResponse,
  ListScorecardContactsResponse,
  ListScorecardsResponse,
  MergeCustomerRecordsRequest,
  ParticipantRole,
  ProblemDetails,
  ProductCatalogConfig,
  RejectCustomerMergeRequest,
  RevokeApiKeyResponse,
  RuleSingleResponse,
  ScorecardFeedbackContent,
  ScorecardTemplate,
  ScorecardTemplateSingleResponse,
  ScorecardTemplateSummaryListResponse,
  ScorecardTemplateSummarySingleResponse,
  ScriptResponse,
  ScriptSectionResponse,
  ScriptStepResponse,
  ScriptStepSentenceResponse,
  ScriptStepStatusResponse,
  ScriptsResponse,
  SearchScorecardSentenceResponse,
  SearchSentencesRequest,
  SearchSentencesResponse,
  SectionListResponse,
  SectionSingleResponse,
  SentenceEntity,
  SingleHookResponse,
  SingleTaskResponse,
  SingleTaskSuggestionResponse,
  Suggestion,
  TaskSuggestionsListResponse,
  TasksListResponse,
  TenantConfig,
  TenantConfigEntity,
  TestSearchResponse,
  TimeInterval,
  UndoMergeCustomerRecordsRequest,
  UpdateContactRoleMappingRequest,
  UpdateContactScriptManifestRequest,
  UpdateContactScriptResponse,
  UpdateCrmIntegrationRequest,
  UpdateCustomerDetailsRequest,
  UpdateExternalServiceRequest,
  UpdateExtractorRequest,
  UpdateFieldRequest,
  UpdateGeneratorRequest,
  UpdateHookRequest,
  UpdateRuleRequest,
  UpdateScorecardRequest,
  UpdateScorecardTemplateRequest,
  UpdateScriptRequest,
  UpdateScriptSectionRequest,
  UpdateScriptStepRequest,
  UpdateSectionRequest,
  UpdateSuggestionRequest,
  UpdateTaskRequest,
  UpdateTeamRequest,
  UpdateTeamUserRequest,
  UpdateUserRequest,
  User,
  Utterance,
} from '../models/index.js';
import {
    ActiveCustomerIdResponseFromJSON,
    ActiveCustomerIdResponseToJSON,
    AddScriptStepFieldRequestFromJSON,
    AddScriptStepFieldRequestToJSON,
    AddScriptStepSentenceRequestFromJSON,
    AddScriptStepSentenceRequestToJSON,
    AddTeamUserRequestFromJSON,
    AddTeamUserRequestToJSON,
    AnalyticsSummaryEntityFromJSON,
    AnalyticsSummaryEntityToJSON,
    AssignCustomerToContactRequestFromJSON,
    AssignCustomerToContactRequestToJSON,
    CallControlsConfigFromJSON,
    CallControlsConfigToJSON,
    CloneScorecardTemplateRequestFromJSON,
    CloneScorecardTemplateRequestToJSON,
    CloseContactRequestFromJSON,
    CloseContactRequestToJSON,
    ContactFromJSON,
    ContactToJSON,
    ContactEventEntityFromJSON,
    ContactEventEntityToJSON,
    ContactSortByFromJSON,
    ContactSortByToJSON,
    ContactSummaryFromJSON,
    ContactSummaryToJSON,
    ContactsTimeIntervalFromJSON,
    ContactsTimeIntervalToJSON,
    CreateApiKeyRequestFromJSON,
    CreateApiKeyRequestToJSON,
    CreateApiKeyResponseFromJSON,
    CreateApiKeyResponseToJSON,
    CreateCommandExecutionRequestFromJSON,
    CreateCommandExecutionRequestToJSON,
    CreateContactEntryRequestFromJSON,
    CreateContactEntryRequestToJSON,
    CreateContactEntryResponseFromJSON,
    CreateContactEntryResponseToJSON,
    CreateContactEventRequestFromJSON,
    CreateContactEventRequestToJSON,
    CreateContactScriptManifestRequestFromJSON,
    CreateContactScriptManifestRequestToJSON,
    CreateContactScriptResponseFromJSON,
    CreateContactScriptResponseToJSON,
    CreateCrmIntegrationRequestFromJSON,
    CreateCrmIntegrationRequestToJSON,
    CreateCustomerNoteRequestFromJSON,
    CreateCustomerNoteRequestToJSON,
    CreateCustomerRequestFromJSON,
    CreateCustomerRequestToJSON,
    CreateExternalServiceRequestFromJSON,
    CreateExternalServiceRequestToJSON,
    CreateExtractorRequestFromJSON,
    CreateExtractorRequestToJSON,
    CreateFieldRequestFromJSON,
    CreateFieldRequestToJSON,
    CreateGeneratorRequestFromJSON,
    CreateGeneratorRequestToJSON,
    CreateHookRequestFromJSON,
    CreateHookRequestToJSON,
    CreateLiveAssistDemoRequestFromJSON,
    CreateLiveAssistDemoRequestToJSON,
    CreateLiveAssistDemoResponseFromJSON,
    CreateLiveAssistDemoResponseToJSON,
    CreateManualQARequestFromJSON,
    CreateManualQARequestToJSON,
    CreateOrUpdateScriptStepStatusRequestFromJSON,
    CreateOrUpdateScriptStepStatusRequestToJSON,
    CreateRuleRequestFromJSON,
    CreateRuleRequestToJSON,
    CreateScorecardRequestFromJSON,
    CreateScorecardRequestToJSON,
    CreateScorecardResponseFromJSON,
    CreateScorecardResponseToJSON,
    CreateScorecardTemplateRequestFromJSON,
    CreateScorecardTemplateRequestToJSON,
    CreateScriptRequestFromJSON,
    CreateScriptRequestToJSON,
    CreateScriptSectionRequestFromJSON,
    CreateScriptSectionRequestToJSON,
    CreateScriptStepRequestFromJSON,
    CreateScriptStepRequestToJSON,
    CreateSearchRequestFromJSON,
    CreateSearchRequestToJSON,
    CreateSearchResponseFromJSON,
    CreateSearchResponseToJSON,
    CreateSectionRequestFromJSON,
    CreateSectionRequestToJSON,
    CreateSentenceRequestFromJSON,
    CreateSentenceRequestToJSON,
    CreateSuggestionRequestFromJSON,
    CreateSuggestionRequestToJSON,
    CreateSuggestionResponseFromJSON,
    CreateSuggestionResponseToJSON,
    CreateTaskFromSuggestionRequestFromJSON,
    CreateTaskFromSuggestionRequestToJSON,
    CreateTaskRequestFromJSON,
    CreateTaskRequestToJSON,
    CreateTeamRequestFromJSON,
    CreateTeamRequestToJSON,
    CreateTeamResponseFromJSON,
    CreateTeamResponseToJSON,
    CreateUserRequestFromJSON,
    CreateUserRequestToJSON,
    CreateUserResponseFromJSON,
    CreateUserResponseToJSON,
    CrmIntegrationResponseFromJSON,
    CrmIntegrationResponseToJSON,
    CrmIntegrationTestCreateCustomerResponseFromJSON,
    CrmIntegrationTestCreateCustomerResponseToJSON,
    CrmIntegrationsResponseFromJSON,
    CrmIntegrationsResponseToJSON,
    CustomerDetailsFromJSON,
    CustomerDetailsToJSON,
    CustomerStatusFromJSON,
    CustomerStatusToJSON,
    CustomersListResponseFromJSON,
    CustomersListResponseToJSON,
    ExternalServiceResponseFromJSON,
    ExternalServiceResponseToJSON,
    ExternalServicesResponseFromJSON,
    ExternalServicesResponseToJSON,
    ExtractSentenceRequestFromJSON,
    ExtractSentenceRequestToJSON,
    ExtractionResponseFromJSON,
    ExtractionResponseToJSON,
    FeedbackSortByFromJSON,
    FeedbackSortByToJSON,
    FieldFromJSON,
    FieldToJSON,
    FieldsResponseFromJSON,
    FieldsResponseToJSON,
    GetAllScorecardFeedbacksResponseFromJSON,
    GetAllScorecardFeedbacksResponseToJSON,
    GetApiKeysResponseFromJSON,
    GetApiKeysResponseToJSON,
    GetContactFieldsResponseFromJSON,
    GetContactFieldsResponseToJSON,
    GetContactScriptResponseFromJSON,
    GetContactScriptResponseToJSON,
    GetContactScriptsResponseFromJSON,
    GetContactScriptsResponseToJSON,
    GetContactTranscriptSummaryResponseFromJSON,
    GetContactTranscriptSummaryResponseToJSON,
    GetContactsResponseFromJSON,
    GetContactsResponseToJSON,
    GetContactsStatsResponseFromJSON,
    GetContactsStatsResponseToJSON,
    GetContactsTimeseriesResponseFromJSON,
    GetContactsTimeseriesResponseToJSON,
    GetCustomerPreviewResponseFromJSON,
    GetCustomerPreviewResponseToJSON,
    GetDemoConvSignedUrlResponseFromJSON,
    GetDemoConvSignedUrlResponseToJSON,
    GetOrderResponseFromJSON,
    GetOrderResponseToJSON,
    GetOrdersResponseFromJSON,
    GetOrdersResponseToJSON,
    GetProductListPreviewResponseFromJSON,
    GetProductListPreviewResponseToJSON,
    GetReviewerScorecardStatsResponseFromJSON,
    GetReviewerScorecardStatsResponseToJSON,
    GetScorecardFeedbacksResponseFromJSON,
    GetScorecardFeedbacksResponseToJSON,
    GetScorecardResponseFromJSON,
    GetScorecardResponseToJSON,
    GetScorecardResultResponseFromJSON,
    GetScorecardResultResponseToJSON,
    GetScriptLogsResponseFromJSON,
    GetScriptLogsResponseToJSON,
    GetTeamResponseFromJSON,
    GetTeamResponseToJSON,
    GetTeamUsersResponseFromJSON,
    GetTeamUsersResponseToJSON,
    GetTeamsResponseFromJSON,
    GetTeamsResponseToJSON,
    GetTenantContactEventsResponseFromJSON,
    GetTenantContactEventsResponseToJSON,
    GetTenantsResponseFromJSON,
    GetTenantsResponseToJSON,
    GetUserResponseFromJSON,
    GetUserResponseToJSON,
    GetUsersResponseFromJSON,
    GetUsersResponseToJSON,
    GuidanceFromJSON,
    GuidanceToJSON,
    LeaderboardEntryEntityFromJSON,
    LeaderboardEntryEntityToJSON,
    ListAgentsResponseFromJSON,
    ListAgentsResponseToJSON,
    ListHooksResponseFromJSON,
    ListHooksResponseToJSON,
    ListScorecardContactsResponseFromJSON,
    ListScorecardContactsResponseToJSON,
    ListScorecardsResponseFromJSON,
    ListScorecardsResponseToJSON,
    MergeCustomerRecordsRequestFromJSON,
    MergeCustomerRecordsRequestToJSON,
    ParticipantRoleFromJSON,
    ParticipantRoleToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ProductCatalogConfigFromJSON,
    ProductCatalogConfigToJSON,
    RejectCustomerMergeRequestFromJSON,
    RejectCustomerMergeRequestToJSON,
    RevokeApiKeyResponseFromJSON,
    RevokeApiKeyResponseToJSON,
    RuleSingleResponseFromJSON,
    RuleSingleResponseToJSON,
    ScorecardFeedbackContentFromJSON,
    ScorecardFeedbackContentToJSON,
    ScorecardTemplateFromJSON,
    ScorecardTemplateToJSON,
    ScorecardTemplateSingleResponseFromJSON,
    ScorecardTemplateSingleResponseToJSON,
    ScorecardTemplateSummaryListResponseFromJSON,
    ScorecardTemplateSummaryListResponseToJSON,
    ScorecardTemplateSummarySingleResponseFromJSON,
    ScorecardTemplateSummarySingleResponseToJSON,
    ScriptResponseFromJSON,
    ScriptResponseToJSON,
    ScriptSectionResponseFromJSON,
    ScriptSectionResponseToJSON,
    ScriptStepResponseFromJSON,
    ScriptStepResponseToJSON,
    ScriptStepSentenceResponseFromJSON,
    ScriptStepSentenceResponseToJSON,
    ScriptStepStatusResponseFromJSON,
    ScriptStepStatusResponseToJSON,
    ScriptsResponseFromJSON,
    ScriptsResponseToJSON,
    SearchScorecardSentenceResponseFromJSON,
    SearchScorecardSentenceResponseToJSON,
    SearchSentencesRequestFromJSON,
    SearchSentencesRequestToJSON,
    SearchSentencesResponseFromJSON,
    SearchSentencesResponseToJSON,
    SectionListResponseFromJSON,
    SectionListResponseToJSON,
    SectionSingleResponseFromJSON,
    SectionSingleResponseToJSON,
    SentenceEntityFromJSON,
    SentenceEntityToJSON,
    SingleHookResponseFromJSON,
    SingleHookResponseToJSON,
    SingleTaskResponseFromJSON,
    SingleTaskResponseToJSON,
    SingleTaskSuggestionResponseFromJSON,
    SingleTaskSuggestionResponseToJSON,
    SuggestionFromJSON,
    SuggestionToJSON,
    TaskSuggestionsListResponseFromJSON,
    TaskSuggestionsListResponseToJSON,
    TasksListResponseFromJSON,
    TasksListResponseToJSON,
    TenantConfigFromJSON,
    TenantConfigToJSON,
    TenantConfigEntityFromJSON,
    TenantConfigEntityToJSON,
    TestSearchResponseFromJSON,
    TestSearchResponseToJSON,
    TimeIntervalFromJSON,
    TimeIntervalToJSON,
    UndoMergeCustomerRecordsRequestFromJSON,
    UndoMergeCustomerRecordsRequestToJSON,
    UpdateContactRoleMappingRequestFromJSON,
    UpdateContactRoleMappingRequestToJSON,
    UpdateContactScriptManifestRequestFromJSON,
    UpdateContactScriptManifestRequestToJSON,
    UpdateContactScriptResponseFromJSON,
    UpdateContactScriptResponseToJSON,
    UpdateCrmIntegrationRequestFromJSON,
    UpdateCrmIntegrationRequestToJSON,
    UpdateCustomerDetailsRequestFromJSON,
    UpdateCustomerDetailsRequestToJSON,
    UpdateExternalServiceRequestFromJSON,
    UpdateExternalServiceRequestToJSON,
    UpdateExtractorRequestFromJSON,
    UpdateExtractorRequestToJSON,
    UpdateFieldRequestFromJSON,
    UpdateFieldRequestToJSON,
    UpdateGeneratorRequestFromJSON,
    UpdateGeneratorRequestToJSON,
    UpdateHookRequestFromJSON,
    UpdateHookRequestToJSON,
    UpdateRuleRequestFromJSON,
    UpdateRuleRequestToJSON,
    UpdateScorecardRequestFromJSON,
    UpdateScorecardRequestToJSON,
    UpdateScorecardTemplateRequestFromJSON,
    UpdateScorecardTemplateRequestToJSON,
    UpdateScriptRequestFromJSON,
    UpdateScriptRequestToJSON,
    UpdateScriptSectionRequestFromJSON,
    UpdateScriptSectionRequestToJSON,
    UpdateScriptStepRequestFromJSON,
    UpdateScriptStepRequestToJSON,
    UpdateSectionRequestFromJSON,
    UpdateSectionRequestToJSON,
    UpdateSuggestionRequestFromJSON,
    UpdateSuggestionRequestToJSON,
    UpdateTaskRequestFromJSON,
    UpdateTaskRequestToJSON,
    UpdateTeamRequestFromJSON,
    UpdateTeamRequestToJSON,
    UpdateTeamUserRequestFromJSON,
    UpdateTeamUserRequestToJSON,
    UpdateUserRequestFromJSON,
    UpdateUserRequestToJSON,
    UserFromJSON,
    UserToJSON,
    UtteranceFromJSON,
    UtteranceToJSON,
} from '../models/index.js';

export interface AddGeneratorToFieldRequest {
    fieldId: number;
    generatorId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface AddScriptStepFieldOperationRequest {
    stepId: number;
    xTenantId?: string;
    xRole?: string;
    addScriptStepFieldRequest?: AddScriptStepFieldRequest;
}

export interface AddScriptStepSentenceOperationRequest {
    stepId: number;
    xTenantId?: string;
    xRole?: string;
    addScriptStepSentenceRequest?: AddScriptStepSentenceRequest;
}

export interface AddTeamUserOperationRequest {
    teamId: number;
    userId: number;
    xTenantId?: string;
    xRole?: string;
    addTeamUserRequest?: AddTeamUserRequest;
}

export interface BatchCreateSentencesRequest {
    xTenantId?: string;
    xRole?: string;
    requestBody?: Array<string>;
}

export interface CloneScorecardTemplateOperationRequest {
    scorecardTemplateId: number;
    xTenantId?: string;
    xRole?: string;
    cloneScorecardTemplateRequest?: CloneScorecardTemplateRequest;
}

export interface CloseContactOperationRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
    closeContactRequest?: CloseContactRequest;
}

export interface CreateApiKeyOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createApiKeyRequest?: CreateApiKeyRequest;
}

export interface CreateChapterCompletionRequest {
    contactId: number;
    chapterId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface CreateCommandExecutionOperationRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
    createCommandExecutionRequest?: CreateCommandExecutionRequest;
}

export interface CreateConfigSentenceRequest {
    xTenantId?: string;
    xRole?: string;
    createSentenceRequest?: CreateSentenceRequest;
}

export interface CreateContactCustomerAssignmentRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
    assignCustomerToContactRequest?: AssignCustomerToContactRequest;
}

export interface CreateContactEventOperationRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
    createContactEventRequest?: CreateContactEventRequest;
}

export interface CreateContactScriptRequest {
    xTenantId?: string;
    xRole?: string;
    createContactScriptManifestRequest?: CreateContactScriptManifestRequest;
}

export interface CreateCrmIntegrationOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createCrmIntegrationRequest?: CreateCrmIntegrationRequest;
}

export interface CreateCustomerEntryRequest {
    customerId: number;
    xTenantId?: string;
    xRole?: string;
    createContactEntryRequest?: CreateContactEntryRequest;
}

export interface CreateCustomerNoteOperationRequest {
    customerId: number;
    xTenantId?: string;
    xRole?: string;
    createCustomerNoteRequest?: CreateCustomerNoteRequest;
}

export interface CreateExternalServiceOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createExternalServiceRequest?: CreateExternalServiceRequest;
}

export interface CreateExtractorOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createExtractorRequest?: CreateExtractorRequest;
}

export interface CreateFieldOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createFieldRequest?: CreateFieldRequest;
}

export interface CreateGeneratorOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createGeneratorRequest?: CreateGeneratorRequest;
}

export interface CreateHookOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createHookRequest?: CreateHookRequest;
}

export interface CreateLiveAssistDemoOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createLiveAssistDemoRequest?: CreateLiveAssistDemoRequest;
}

export interface CreateOrUpdateScriptStepStatusOperationRequest {
    contactId: number;
    stepId: number;
    xTenantId?: string;
    xRole?: string;
    createOrUpdateScriptStepStatusRequest?: CreateOrUpdateScriptStepStatusRequest;
}

export interface CreateRuleOperationRequest {
    scorecardTemplateId: number;
    xTenantId?: string;
    xRole?: string;
    createRuleRequest?: CreateRuleRequest;
}

export interface CreateScorecardOperationRequest {
    templateId: number;
    xTenantId?: string;
    xRole?: string;
    createScorecardRequest?: CreateScorecardRequest;
}

export interface CreateScorecardFeedbackRequest {
    scorecardId: number;
    xTenantId?: string;
    xRole?: string;
    scorecardFeedbackContent?: ScorecardFeedbackContent;
}

export interface CreateScorecardTemplateOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createScorecardTemplateRequest?: CreateScorecardTemplateRequest;
}

export interface CreateScriptOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createScriptRequest?: CreateScriptRequest;
}

export interface CreateScriptSectionOperationRequest {
    scriptId: number;
    xTenantId?: string;
    xRole?: string;
    createScriptSectionRequest?: CreateScriptSectionRequest;
}

export interface CreateScriptStepOperationRequest {
    sectionId: number;
    xTenantId?: string;
    xRole?: string;
    createScriptStepRequest?: CreateScriptStepRequest;
}

export interface CreateSearchOperationRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
    createSearchRequest?: CreateSearchRequest;
}

export interface CreateSectionOperationRequest {
    scorecardTemplateId: number;
    xTenantId?: string;
    xRole?: string;
    createSectionRequest?: CreateSectionRequest;
}

export interface CreateSuggestionOperationRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
    createSuggestionRequest?: CreateSuggestionRequest;
}

export interface CreateTaskOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createTaskRequest?: CreateTaskRequest;
}

export interface CreateTaskFromSuggestionOperationRequest {
    taskSuggestionId: number;
    xTenantId?: string;
    xRole?: string;
    createTaskFromSuggestionRequest?: CreateTaskFromSuggestionRequest;
}

export interface CreateTeamOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createTeamRequest?: CreateTeamRequest;
}

export interface CreateUserOperationRequest {
    xTenantId?: string;
    xRole?: string;
    createUserRequest?: CreateUserRequest;
}

export interface DeleteChapterCompletionRequest {
    contactId: number;
    chapterId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteContactEventRequest {
    contactId: number;
    eventId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteContactScriptRequest {
    scriptId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteCrmIntegrationRequest {
    integrationId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteCustomerEntryRequest {
    customerEntryId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteExternalServiceRequest {
    serviceId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteExtractorRequest {
    extractorId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteFieldRequest {
    fieldId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteGeneratorRequest {
    generatorId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteHookRequest {
    hookId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteScorecardRequest {
    scorecardId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteScorecardTemplateRequest {
    scorecardTemplateId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteScriptRequest {
    scriptId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteScriptSectionRequest {
    sectionId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteScriptStepRequest {
    stepId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteScriptStepFieldRequest {
    stepId: number;
    fieldId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteScriptStepSentenceRequest {
    stepId: number;
    sentenceId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteSectionRequest {
    sectionId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteTaskRequest {
    taskId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteTeamRequest {
    teamId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DeleteUserRequest {
    userId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface DemoCompareSentencesRequest {
    xTenantId?: string;
    xRole?: string;
    requestBody?: Array<string>;
}

export interface EnableScriptLoggingRequest {
    scriptId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface EvaulateScorecardRequest {
    scorecardId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface ExportScorecardFeedbackRequest {
    sortBy?: FeedbackSortBy;
    filterDateMin?: Date;
    filterDateMax?: Date;
    desc?: boolean;
    xTenantId?: string;
    xRole?: string;
}

export interface ExtCreateManualQARequest {
    scorecardId: number;
    xTenantId?: string;
    xRole?: string;
    createManualQARequest?: CreateManualQARequest;
}

export interface ExtGetContactAudioUriRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface ExtractSentencesRequest {
    xTenantId?: string;
    xRole?: string;
    extractSentenceRequest?: ExtractSentenceRequest;
}

export interface GetAllScorecardFeedbacksRequest {
    sortBy?: FeedbackSortBy;
    filterDateMin?: Date;
    filterDateMax?: Date;
    desc?: boolean;
    page?: number;
    pageSize?: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetAnalyticsSummaryRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetApiKeysRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetCallControlsConfigRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetConfigRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactBySourceIdRequest {
    sourceId: string;
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactEventsRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactFieldsRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactGuidanceRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactProductRecommendationsRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactScriptRequest {
    scriptId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactScriptsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactScriptsTypeDefinitionsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactSuggestionsRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactTranscriptSummaryRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactUtterancesRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactsStatsRequest {
    users?: Array<number>;
    teams?: Array<number>;
    filterDateMin?: Date;
    filterDateMax?: Date;
    filterPhoneNumber?: string;
    filterScoreMin?: number;
    filterScoreMax?: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactsTimeseriesRequest {
    filterDateMin?: Date;
    filterDateMax?: Date;
    interval?: ContactsTimeInterval;
    teams?: Array<number>;
    xTenantId?: string;
    xRole?: string;
}

export interface GetContactsV2Request {
    sortBy?: ContactSortBy;
    users?: Array<number>;
    teams?: Array<number>;
    filterDateMin?: Date;
    filterDateMax?: Date;
    filterPhoneNumber?: string;
    filterScoreMin?: number;
    filterScoreMax?: number;
    desc?: boolean;
    page?: number;
    pageSize?: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetCrmIntegrationRequest {
    integrationId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetCrmIntegrationsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetCurrentUserRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetCustomerDetailsRequest {
    customerId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetCustomerEntriesRequest {
    customerId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetCustomerFieldsRequest {
    customerId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetCustomerOrdersRequest {
    customerId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetCustomerPreviewRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetCustomerStatusesRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetDemoConvSignedUrlRequest {
    agentId?: string;
    xTenantId?: string;
    xRole?: string;
}

export interface GetExternalServiceRequest {
    serviceId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetExternalServicesRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetExtractorsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetFieldGeneratorsRequest {
    fieldId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetFieldsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetGeneratorsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetGlobalTenantConfigRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetLeaderboardRequest {
    startTime?: Date;
    endTime?: Date;
    xTenantId?: string;
    xRole?: string;
}

export interface GetOrderRequest {
    orderId: string;
    xTenantId?: string;
    xRole?: string;
}

export interface GetProductCatalogConfigRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetProductListPreviewRequest {
    xTenantId?: string;
    xRole?: string;
    requestBody?: { [key: string]: any; };
}

export interface GetReviewManagerScorecardStatsRequest {
    filterDateMin?: Date;
    filterDateMax?: Date;
    interval?: TimeInterval;
    xTenantId?: string;
    xRole?: string;
}

export interface GetReviewerScorecardStatsRequest {
    filterDateMin?: Date;
    filterDateMax?: Date;
    interval?: TimeInterval;
    xTenantId?: string;
    xRole?: string;
}

export interface GetScorecardRequest {
    scorecardId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetScorecardFeedbacksRequest {
    scorecardId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetScorecardRuleScriptTypesRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetScorecardTemplateRequest {
    scorecardTemplateId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetScriptRequest {
    scriptId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetScriptLogsRequest {
    scriptId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetScriptsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetSectionRequest {
    sectionId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetSentencesRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetTaskRequest {
    taskId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetTaskSuggestionRequest {
    taskSuggestionId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetTeamRequest {
    teamId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetTeamUsersRequest {
    teamId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetTeamsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetTenantContactEventsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetTenantsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetUserRequest {
    userId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetUserOrdersRequest {
    userId: number;
    isActive?: boolean;
    xTenantId?: string;
    xRole?: string;
}

export interface GetUserTaskSuggestionsRequest {
    contactId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface GetUserTasksRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface GetUsersRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface ImportScorecardRequest {
    xTenantId?: string;
    xRole?: string;
    scorecardTemplate?: ScorecardTemplate;
}

export interface ListAgentsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface ListHooksRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface ListScorecardContactsRequest {
    scorecardId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface ListScorecardTemplatesRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface ListScorecardsRequest {
    xTenantId?: string;
    xRole?: string;
}

export interface ListSectionsRequest {
    scorecardTemplateId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface MergeCustomerRecordsOperationRequest {
    xTenantId?: string;
    xRole?: string;
    mergeCustomerRecordsRequest?: MergeCustomerRecordsRequest;
}

export interface MergeRejectSuggestionRequest {
    xTenantId?: string;
    xRole?: string;
    rejectCustomerMergeRequest?: RejectCustomerMergeRequest;
}

export interface RefreshSearchRequest {
    searchId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface RejectTaskSuggestionRequest {
    taskSuggestionId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface RemoveGeneratorFromFieldRequest {
    fieldId: number;
    generatorId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface RemoveTeamUserRequest {
    teamId: number;
    userId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface ReorderSectionRulesRequest {
    sectionId: number;
    xTenantId?: string;
    xRole?: string;
    requestBody?: Array<number>;
}

export interface ReorderSectionsRequest {
    scorecardTemplateId: number;
    xTenantId?: string;
    xRole?: string;
    requestBody?: Array<number>;
}

export interface RevokeApiKeyRequest {
    apiKeyId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface SearchCustomersRequest {
    query?: string;
    page?: number;
    pageSize?: number;
    orderBy?: string;
    orderDesc?: boolean;
    xTenantId?: string;
    xRole?: string;
}

export interface SearchScorecardSentenceRequest {
    scorecardId: number;
    sample?: string;
    role?: ParticipantRole;
    xTenantId?: string;
    xRole?: string;
}

export interface SearchSentencesOperationRequest {
    limit?: number;
    xTenantId?: string;
    xRole?: string;
    searchSentencesRequest?: SearchSentencesRequest;
}

export interface SmmarizeContactRequest {
    contactId: number;
    tier?: string;
    chunkSize?: number;
    xTenantId?: string;
    xRole?: string;
}

export interface TestContactScriptRequest {
    scriptId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface TestCustomCrmIntegrationCreateCustomerRequest {
    xTenantId?: string;
    xRole?: string;
    requestBody?: { [key: string]: any; };
}

export interface TestExternalServiceCreateCustomerRequest {
    serviceId: number;
    xTenantId?: string;
    xRole?: string;
    createCustomerRequest?: CreateCustomerRequest;
}

export interface TestSearchRequest {
    fieldId?: number;
    query?: string;
    xTenantId?: string;
    xRole?: string;
}

export interface UndoMergeCustomerRecordsOperationRequest {
    xTenantId?: string;
    xRole?: string;
    undoMergeCustomerRecordsRequest?: UndoMergeCustomerRecordsRequest;
}

export interface UpdateContactRoleMappingsRequest {
    scorecardId: number;
    xTenantId?: string;
    xRole?: string;
    updateContactRoleMappingRequest?: UpdateContactRoleMappingRequest;
}

export interface UpdateContactScriptRequest {
    scriptId: number;
    xTenantId?: string;
    xRole?: string;
    updateContactScriptManifestRequest?: UpdateContactScriptManifestRequest;
}

export interface UpdateCrmIntegrationOperationRequest {
    integrationId: number;
    xTenantId?: string;
    xRole?: string;
    updateCrmIntegrationRequest?: UpdateCrmIntegrationRequest;
}

export interface UpdateCustomerRequest {
    customerId: number;
    xTenantId?: string;
    xRole?: string;
    updateCustomerDetailsRequest?: UpdateCustomerDetailsRequest;
}

export interface UpdateExternalServiceOperationRequest {
    serviceId: number;
    xTenantId?: string;
    xRole?: string;
    updateExternalServiceRequest?: UpdateExternalServiceRequest;
}

export interface UpdateExtractorOperationRequest {
    extractorId: number;
    xTenantId?: string;
    xRole?: string;
    updateExtractorRequest?: UpdateExtractorRequest;
}

export interface UpdateFieldOperationRequest {
    fieldId: number;
    xTenantId?: string;
    xRole?: string;
    updateFieldRequest?: UpdateFieldRequest;
}

export interface UpdateGeneratorOperationRequest {
    generatorId: number;
    xTenantId?: string;
    xRole?: string;
    updateGeneratorRequest?: UpdateGeneratorRequest;
}

export interface UpdateGuidanceStatusRequest {
    contactId: number;
    guidanceId: number;
    xTenantId?: string;
    xRole?: string;
}

export interface UpdateHookOperationRequest {
    hookId: number;
    xTenantId?: string;
    xRole?: string;
    updateHookRequest?: UpdateHookRequest;
}

export interface UpdateRuleOperationRequest {
    ruleId: number;
    xTenantId?: string;
    xRole?: string;
    updateRuleRequest?: UpdateRuleRequest;
}

export interface UpdateScorecardOperationRequest {
    scorecardId: number;
    xTenantId?: string;
    xRole?: string;
    updateScorecardRequest?: UpdateScorecardRequest;
}

export interface UpdateScorecardRulesOrderRequest {
    scorecardTemplateId: number;
    xTenantId?: string;
    xRole?: string;
    requestBody?: Array<number>;
}

export interface UpdateScorecardTemplateOperationRequest {
    scorecardTemplateId: number;
    xTenantId?: string;
    xRole?: string;
    updateScorecardTemplateRequest?: UpdateScorecardTemplateRequest;
}

export interface UpdateScriptOperationRequest {
    scriptId: number;
    xTenantId?: string;
    xRole?: string;
    updateScriptRequest?: UpdateScriptRequest;
}

export interface UpdateScriptSectionOperationRequest {
    sectionId: number;
    xTenantId?: string;
    xRole?: string;
    updateScriptSectionRequest?: UpdateScriptSectionRequest;
}

export interface UpdateScriptStepOperationRequest {
    stepId: number;
    xTenantId?: string;
    xRole?: string;
    updateScriptStepRequest?: UpdateScriptStepRequest;
}

export interface UpdateSectionOperationRequest {
    sectionId: number;
    xTenantId?: string;
    xRole?: string;
    updateSectionRequest?: UpdateSectionRequest;
}

export interface UpdateSuggestionOperationRequest {
    suggestionId: number;
    xTenantId?: string;
    xRole?: string;
    updateSuggestionRequest?: UpdateSuggestionRequest;
}

export interface UpdateTaskOperationRequest {
    taskId: number;
    xTenantId?: string;
    xRole?: string;
    updateTaskRequest?: UpdateTaskRequest;
}

export interface UpdateTeamOperationRequest {
    teamId: number;
    xTenantId?: string;
    xRole?: string;
    updateTeamRequest?: UpdateTeamRequest;
}

export interface UpdateTeamUserOperationRequest {
    teamId: number;
    userId: number;
    xTenantId?: string;
    xRole?: string;
    updateTeamUserRequest?: UpdateTeamUserRequest;
}

export interface UpdateUserOperationRequest {
    userId: number;
    xTenantId?: string;
    xRole?: string;
    updateUserRequest?: UpdateUserRequest;
}

/**
 * 
 */
export class JackBurtonApi extends runtime.BaseAPI {

    /**
     */
    async addGeneratorToFieldRaw(requestParameters: AddGeneratorToFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fieldId'] == null) {
            throw new runtime.RequiredError(
                'fieldId',
                'Required parameter "fieldId" was null or undefined when calling addGeneratorToField().'
            );
        }

        if (requestParameters['generatorId'] == null) {
            throw new runtime.RequiredError(
                'generatorId',
                'Required parameter "generatorId" was null or undefined when calling addGeneratorToField().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/fields/{fieldId}/generators/{generatorId}`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))).replace(`{${"generatorId"}}`, encodeURIComponent(String(requestParameters['generatorId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addGeneratorToField(requestParameters: AddGeneratorToFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addGeneratorToFieldRaw(requestParameters, initOverrides);
    }

    /**
     */
    async addScriptStepFieldRaw(requestParameters: AddScriptStepFieldOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['stepId'] == null) {
            throw new runtime.RequiredError(
                'stepId',
                'Required parameter "stepId" was null or undefined when calling addScriptStepField().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/steps/{stepId}/fields`.replace(`{${"stepId"}}`, encodeURIComponent(String(requestParameters['stepId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddScriptStepFieldRequestToJSON(requestParameters['addScriptStepFieldRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addScriptStepField(requestParameters: AddScriptStepFieldOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addScriptStepFieldRaw(requestParameters, initOverrides);
    }

    /**
     */
    async addScriptStepSentenceRaw(requestParameters: AddScriptStepSentenceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScriptStepSentenceResponse>> {
        if (requestParameters['stepId'] == null) {
            throw new runtime.RequiredError(
                'stepId',
                'Required parameter "stepId" was null or undefined when calling addScriptStepSentence().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/steps/{stepId}/sentences`.replace(`{${"stepId"}}`, encodeURIComponent(String(requestParameters['stepId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddScriptStepSentenceRequestToJSON(requestParameters['addScriptStepSentenceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScriptStepSentenceResponseFromJSON(jsonValue));
    }

    /**
     */
    async addScriptStepSentence(requestParameters: AddScriptStepSentenceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScriptStepSentenceResponse> {
        const response = await this.addScriptStepSentenceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async addTeamUserRaw(requestParameters: AddTeamUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling addTeamUser().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling addTeamUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/teams/{teamId}/users/{userId}`.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId']))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddTeamUserRequestToJSON(requestParameters['addTeamUserRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addTeamUser(requestParameters: AddTeamUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addTeamUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async batchCreateSentencesRaw(requestParameters: BatchCreateSentencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SentenceEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/sentence_batches`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SentenceEntityFromJSON));
    }

    /**
     */
    async batchCreateSentences(requestParameters: BatchCreateSentencesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SentenceEntity>> {
        const response = await this.batchCreateSentencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async cloneScorecardTemplateRaw(requestParameters: CloneScorecardTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScorecardTemplateSummarySingleResponse>> {
        if (requestParameters['scorecardTemplateId'] == null) {
            throw new runtime.RequiredError(
                'scorecardTemplateId',
                'Required parameter "scorecardTemplateId" was null or undefined when calling cloneScorecardTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecard-templates/{scorecardTemplateId}/clone`.replace(`{${"scorecardTemplateId"}}`, encodeURIComponent(String(requestParameters['scorecardTemplateId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CloneScorecardTemplateRequestToJSON(requestParameters['cloneScorecardTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScorecardTemplateSummarySingleResponseFromJSON(jsonValue));
    }

    /**
     */
    async cloneScorecardTemplate(requestParameters: CloneScorecardTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScorecardTemplateSummarySingleResponse> {
        const response = await this.cloneScorecardTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async closeContactRaw(requestParameters: CloseContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling closeContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/closure`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CloseContactRequestToJSON(requestParameters['closeContactRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async closeContact(requestParameters: CloseContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.closeContactRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createApiKeyRaw(requestParameters: CreateApiKeyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateApiKeyResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/api-keys`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateApiKeyRequestToJSON(requestParameters['createApiKeyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateApiKeyResponseFromJSON(jsonValue));
    }

    /**
     */
    async createApiKey(requestParameters: CreateApiKeyOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateApiKeyResponse> {
        const response = await this.createApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createChapterCompletionRaw(requestParameters: CreateChapterCompletionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling createChapterCompletion().'
            );
        }

        if (requestParameters['chapterId'] == null) {
            throw new runtime.RequiredError(
                'chapterId',
                'Required parameter "chapterId" was null or undefined when calling createChapterCompletion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/chapters/{chapterId}/completion`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))).replace(`{${"chapterId"}}`, encodeURIComponent(String(requestParameters['chapterId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createChapterCompletion(requestParameters: CreateChapterCompletionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createChapterCompletionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createCommandExecutionRaw(requestParameters: CreateCommandExecutionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling createCommandExecution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/command_execution`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCommandExecutionRequestToJSON(requestParameters['createCommandExecutionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createCommandExecution(requestParameters: CreateCommandExecutionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createCommandExecutionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createConfigSentenceRaw(requestParameters: CreateConfigSentenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/sentences`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSentenceRequestToJSON(requestParameters['createSentenceRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createConfigSentence(requestParameters: CreateConfigSentenceRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createConfigSentenceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createContactCustomerAssignmentRaw(requestParameters: CreateContactCustomerAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling createContactCustomerAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/customer`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignCustomerToContactRequestToJSON(requestParameters['assignCustomerToContactRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createContactCustomerAssignment(requestParameters: CreateContactCustomerAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createContactCustomerAssignmentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createContactEventRaw(requestParameters: CreateContactEventOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateContactEventRequest>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling createContactEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/events`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateContactEventRequestToJSON(requestParameters['createContactEventRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateContactEventRequestFromJSON(jsonValue));
    }

    /**
     */
    async createContactEvent(requestParameters: CreateContactEventOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateContactEventRequest> {
        const response = await this.createContactEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createContactScriptRaw(requestParameters: CreateContactScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateContactScriptResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scripts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateContactScriptManifestRequestToJSON(requestParameters['createContactScriptManifestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateContactScriptResponseFromJSON(jsonValue));
    }

    /**
     */
    async createContactScript(requestParameters: CreateContactScriptRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateContactScriptResponse> {
        const response = await this.createContactScriptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createCrmIntegrationRaw(requestParameters: CreateCrmIntegrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmIntegrationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/integrations/crm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCrmIntegrationRequestToJSON(requestParameters['createCrmIntegrationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmIntegrationResponseFromJSON(jsonValue));
    }

    /**
     */
    async createCrmIntegration(requestParameters: CreateCrmIntegrationOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmIntegrationResponse> {
        const response = await this.createCrmIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createCustomerEntryRaw(requestParameters: CreateCustomerEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateContactEntryResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createCustomerEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customers/{customerId}/entries`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateContactEntryRequestToJSON(requestParameters['createContactEntryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateContactEntryResponseFromJSON(jsonValue));
    }

    /**
     */
    async createCustomerEntry(requestParameters: CreateCustomerEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateContactEntryResponse> {
        const response = await this.createCustomerEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createCustomerNoteRaw(requestParameters: CreateCustomerNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createCustomerNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customers/{customerId}/notes`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCustomerNoteRequestToJSON(requestParameters['createCustomerNoteRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createCustomerNote(requestParameters: CreateCustomerNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createCustomerNoteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createExternalServiceRaw(requestParameters: CreateExternalServiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalServiceResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/external-services`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExternalServiceRequestToJSON(requestParameters['createExternalServiceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalServiceResponseFromJSON(jsonValue));
    }

    /**
     */
    async createExternalService(requestParameters: CreateExternalServiceOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalServiceResponse> {
        const response = await this.createExternalServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createExtractorRaw(requestParameters: CreateExtractorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFieldRequest>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/extractors`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExtractorRequestToJSON(requestParameters['createExtractorRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFieldRequestFromJSON(jsonValue));
    }

    /**
     */
    async createExtractor(requestParameters: CreateExtractorOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFieldRequest> {
        const response = await this.createExtractorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createFieldRaw(requestParameters: CreateFieldOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFieldRequest>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/fields`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFieldRequestToJSON(requestParameters['createFieldRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFieldRequestFromJSON(jsonValue));
    }

    /**
     */
    async createField(requestParameters: CreateFieldOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFieldRequest> {
        const response = await this.createFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createGeneratorRaw(requestParameters: CreateGeneratorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateGeneratorRequest>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/generators`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateGeneratorRequestToJSON(requestParameters['createGeneratorRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateGeneratorRequestFromJSON(jsonValue));
    }

    /**
     */
    async createGenerator(requestParameters: CreateGeneratorOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateGeneratorRequest> {
        const response = await this.createGeneratorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createHookRaw(requestParameters: CreateHookOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleHookResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/hooks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateHookRequestToJSON(requestParameters['createHookRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SingleHookResponseFromJSON(jsonValue));
    }

    /**
     */
    async createHook(requestParameters: CreateHookOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleHookResponse> {
        const response = await this.createHookRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createLiveAssistDemoRaw(requestParameters: CreateLiveAssistDemoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLiveAssistDemoResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/demo/live-assist`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLiveAssistDemoRequestToJSON(requestParameters['createLiveAssistDemoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLiveAssistDemoResponseFromJSON(jsonValue));
    }

    /**
     */
    async createLiveAssistDemo(requestParameters: CreateLiveAssistDemoOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLiveAssistDemoResponse> {
        const response = await this.createLiveAssistDemoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createOrUpdateScriptStepStatusRaw(requestParameters: CreateOrUpdateScriptStepStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScriptStepStatusResponse>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling createOrUpdateScriptStepStatus().'
            );
        }

        if (requestParameters['stepId'] == null) {
            throw new runtime.RequiredError(
                'stepId',
                'Required parameter "stepId" was null or undefined when calling createOrUpdateScriptStepStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/scripts/steps/{stepId}/status`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))).replace(`{${"stepId"}}`, encodeURIComponent(String(requestParameters['stepId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateScriptStepStatusRequestToJSON(requestParameters['createOrUpdateScriptStepStatusRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScriptStepStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async createOrUpdateScriptStepStatus(requestParameters: CreateOrUpdateScriptStepStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScriptStepStatusResponse> {
        const response = await this.createOrUpdateScriptStepStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createRuleRaw(requestParameters: CreateRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RuleSingleResponse>> {
        if (requestParameters['scorecardTemplateId'] == null) {
            throw new runtime.RequiredError(
                'scorecardTemplateId',
                'Required parameter "scorecardTemplateId" was null or undefined when calling createRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecard-templates/{scorecardTemplateId}/rules`.replace(`{${"scorecardTemplateId"}}`, encodeURIComponent(String(requestParameters['scorecardTemplateId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRuleRequestToJSON(requestParameters['createRuleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RuleSingleResponseFromJSON(jsonValue));
    }

    /**
     */
    async createRule(requestParameters: CreateRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RuleSingleResponse> {
        const response = await this.createRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createScorecardRaw(requestParameters: CreateScorecardOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateScorecardResponse>> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling createScorecard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/scorecard-templates/{templateId}/scorecards`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters['templateId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateScorecardRequestToJSON(requestParameters['createScorecardRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateScorecardResponseFromJSON(jsonValue));
    }

    /**
     */
    async createScorecard(requestParameters: CreateScorecardOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateScorecardResponse> {
        const response = await this.createScorecardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createScorecardFeedbackRaw(requestParameters: CreateScorecardFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['scorecardId'] == null) {
            throw new runtime.RequiredError(
                'scorecardId',
                'Required parameter "scorecardId" was null or undefined when calling createScorecardFeedback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/{scorecardId}/feedback`.replace(`{${"scorecardId"}}`, encodeURIComponent(String(requestParameters['scorecardId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScorecardFeedbackContentToJSON(requestParameters['scorecardFeedbackContent']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createScorecardFeedback(requestParameters: CreateScorecardFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createScorecardFeedbackRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createScorecardTemplateRaw(requestParameters: CreateScorecardTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScorecardTemplateSingleResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecard-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateScorecardTemplateRequestToJSON(requestParameters['createScorecardTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScorecardTemplateSingleResponseFromJSON(jsonValue));
    }

    /**
     */
    async createScorecardTemplate(requestParameters: CreateScorecardTemplateOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScorecardTemplateSingleResponse> {
        const response = await this.createScorecardTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createScriptRaw(requestParameters: CreateScriptOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScriptResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateScriptRequestToJSON(requestParameters['createScriptRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScriptResponseFromJSON(jsonValue));
    }

    /**
     */
    async createScript(requestParameters: CreateScriptOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScriptResponse> {
        const response = await this.createScriptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createScriptSectionRaw(requestParameters: CreateScriptSectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScriptSectionResponse>> {
        if (requestParameters['scriptId'] == null) {
            throw new runtime.RequiredError(
                'scriptId',
                'Required parameter "scriptId" was null or undefined when calling createScriptSection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/{scriptId}/sections`.replace(`{${"scriptId"}}`, encodeURIComponent(String(requestParameters['scriptId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateScriptSectionRequestToJSON(requestParameters['createScriptSectionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScriptSectionResponseFromJSON(jsonValue));
    }

    /**
     */
    async createScriptSection(requestParameters: CreateScriptSectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScriptSectionResponse> {
        const response = await this.createScriptSectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createScriptStepRaw(requestParameters: CreateScriptStepOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScriptStepResponse>> {
        if (requestParameters['sectionId'] == null) {
            throw new runtime.RequiredError(
                'sectionId',
                'Required parameter "sectionId" was null or undefined when calling createScriptStep().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/sections/{sectionId}/steps`.replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters['sectionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateScriptStepRequestToJSON(requestParameters['createScriptStepRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScriptStepResponseFromJSON(jsonValue));
    }

    /**
     */
    async createScriptStep(requestParameters: CreateScriptStepOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScriptStepResponse> {
        const response = await this.createScriptStepRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createSearchRaw(requestParameters: CreateSearchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSearchResponse>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling createSearch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/search`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSearchRequestToJSON(requestParameters['createSearchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSearchResponseFromJSON(jsonValue));
    }

    /**
     */
    async createSearch(requestParameters: CreateSearchOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSearchResponse> {
        const response = await this.createSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createSectionRaw(requestParameters: CreateSectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SectionSingleResponse>> {
        if (requestParameters['scorecardTemplateId'] == null) {
            throw new runtime.RequiredError(
                'scorecardTemplateId',
                'Required parameter "scorecardTemplateId" was null or undefined when calling createSection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecard-templates/{scorecardTemplateId}/sections`.replace(`{${"scorecardTemplateId"}}`, encodeURIComponent(String(requestParameters['scorecardTemplateId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSectionRequestToJSON(requestParameters['createSectionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SectionSingleResponseFromJSON(jsonValue));
    }

    /**
     */
    async createSection(requestParameters: CreateSectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SectionSingleResponse> {
        const response = await this.createSectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createSuggestionRaw(requestParameters: CreateSuggestionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSuggestionResponse>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling createSuggestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/suggestions`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSuggestionRequestToJSON(requestParameters['createSuggestionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSuggestionResponseFromJSON(jsonValue));
    }

    /**
     */
    async createSuggestion(requestParameters: CreateSuggestionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSuggestionResponse> {
        const response = await this.createSuggestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createTaskRaw(requestParameters: CreateTaskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleTaskResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/tasks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTaskRequestToJSON(requestParameters['createTaskRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SingleTaskResponseFromJSON(jsonValue));
    }

    /**
     */
    async createTask(requestParameters: CreateTaskOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleTaskResponse> {
        const response = await this.createTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createTaskFromSuggestionRaw(requestParameters: CreateTaskFromSuggestionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleTaskSuggestionResponse>> {
        if (requestParameters['taskSuggestionId'] == null) {
            throw new runtime.RequiredError(
                'taskSuggestionId',
                'Required parameter "taskSuggestionId" was null or undefined when calling createTaskFromSuggestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/task-suggestions/{taskSuggestionId}/tasks`.replace(`{${"taskSuggestionId"}}`, encodeURIComponent(String(requestParameters['taskSuggestionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTaskFromSuggestionRequestToJSON(requestParameters['createTaskFromSuggestionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SingleTaskSuggestionResponseFromJSON(jsonValue));
    }

    /**
     */
    async createTaskFromSuggestion(requestParameters: CreateTaskFromSuggestionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleTaskSuggestionResponse> {
        const response = await this.createTaskFromSuggestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createTeamRaw(requestParameters: CreateTeamOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTeamResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/teams`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTeamRequestToJSON(requestParameters['createTeamRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateTeamResponseFromJSON(jsonValue));
    }

    /**
     */
    async createTeam(requestParameters: CreateTeamOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTeamResponse> {
        const response = await this.createTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createUserRaw(requestParameters: CreateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserRequestToJSON(requestParameters['createUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async createUser(requestParameters: CreateUserOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserResponse> {
        const response = await this.createUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteChapterCompletionRaw(requestParameters: DeleteChapterCompletionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling deleteChapterCompletion().'
            );
        }

        if (requestParameters['chapterId'] == null) {
            throw new runtime.RequiredError(
                'chapterId',
                'Required parameter "chapterId" was null or undefined when calling deleteChapterCompletion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/chapters/{chapterId}/completion`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))).replace(`{${"chapterId"}}`, encodeURIComponent(String(requestParameters['chapterId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteChapterCompletion(requestParameters: DeleteChapterCompletionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteChapterCompletionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteContactEventRaw(requestParameters: DeleteContactEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactEventEntity>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling deleteContactEvent().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteContactEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/events/{eventId}`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))).replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactEventEntityFromJSON(jsonValue));
    }

    /**
     */
    async deleteContactEvent(requestParameters: DeleteContactEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactEventEntity> {
        const response = await this.deleteContactEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteContactScriptRaw(requestParameters: DeleteContactScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['scriptId'] == null) {
            throw new runtime.RequiredError(
                'scriptId',
                'Required parameter "scriptId" was null or undefined when calling deleteContactScript().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scripts/{scriptId}`.replace(`{${"scriptId"}}`, encodeURIComponent(String(requestParameters['scriptId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteContactScript(requestParameters: DeleteContactScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteContactScriptRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteCrmIntegrationRaw(requestParameters: DeleteCrmIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling deleteCrmIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/integrations/crm/{integrationId}`.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCrmIntegration(requestParameters: DeleteCrmIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCrmIntegrationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteCustomerEntryRaw(requestParameters: DeleteCustomerEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerEntryId'] == null) {
            throw new runtime.RequiredError(
                'customerEntryId',
                'Required parameter "customerEntryId" was null or undefined when calling deleteCustomerEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customer_entries/{customerEntryId}`.replace(`{${"customerEntryId"}}`, encodeURIComponent(String(requestParameters['customerEntryId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCustomerEntry(requestParameters: DeleteCustomerEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCustomerEntryRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteExternalServiceRaw(requestParameters: DeleteExternalServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling deleteExternalService().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/external-services/{serviceId}`.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteExternalService(requestParameters: DeleteExternalServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteExternalServiceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteExtractorRaw(requestParameters: DeleteExtractorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['extractorId'] == null) {
            throw new runtime.RequiredError(
                'extractorId',
                'Required parameter "extractorId" was null or undefined when calling deleteExtractor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/extractors/{extractorId}`.replace(`{${"extractorId"}}`, encodeURIComponent(String(requestParameters['extractorId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteExtractor(requestParameters: DeleteExtractorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteExtractorRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteFieldRaw(requestParameters: DeleteFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fieldId'] == null) {
            throw new runtime.RequiredError(
                'fieldId',
                'Required parameter "fieldId" was null or undefined when calling deleteField().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/fields/{fieldId}`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteField(requestParameters: DeleteFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFieldRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteGeneratorRaw(requestParameters: DeleteGeneratorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['generatorId'] == null) {
            throw new runtime.RequiredError(
                'generatorId',
                'Required parameter "generatorId" was null or undefined when calling deleteGenerator().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/generators/{generatorId}`.replace(`{${"generatorId"}}`, encodeURIComponent(String(requestParameters['generatorId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteGenerator(requestParameters: DeleteGeneratorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteGeneratorRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteHookRaw(requestParameters: DeleteHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['hookId'] == null) {
            throw new runtime.RequiredError(
                'hookId',
                'Required parameter "hookId" was null or undefined when calling deleteHook().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/hooks/{hookId}`.replace(`{${"hookId"}}`, encodeURIComponent(String(requestParameters['hookId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteHook(requestParameters: DeleteHookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteHookRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteScorecardRaw(requestParameters: DeleteScorecardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['scorecardId'] == null) {
            throw new runtime.RequiredError(
                'scorecardId',
                'Required parameter "scorecardId" was null or undefined when calling deleteScorecard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/{scorecardId}`.replace(`{${"scorecardId"}}`, encodeURIComponent(String(requestParameters['scorecardId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteScorecard(requestParameters: DeleteScorecardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScorecardRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteScorecardTemplateRaw(requestParameters: DeleteScorecardTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['scorecardTemplateId'] == null) {
            throw new runtime.RequiredError(
                'scorecardTemplateId',
                'Required parameter "scorecardTemplateId" was null or undefined when calling deleteScorecardTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecard-templates/{scorecardTemplateId}`.replace(`{${"scorecardTemplateId"}}`, encodeURIComponent(String(requestParameters['scorecardTemplateId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteScorecardTemplate(requestParameters: DeleteScorecardTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScorecardTemplateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteScriptRaw(requestParameters: DeleteScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['scriptId'] == null) {
            throw new runtime.RequiredError(
                'scriptId',
                'Required parameter "scriptId" was null or undefined when calling deleteScript().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/{scriptId}`.replace(`{${"scriptId"}}`, encodeURIComponent(String(requestParameters['scriptId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteScript(requestParameters: DeleteScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScriptRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteScriptSectionRaw(requestParameters: DeleteScriptSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sectionId'] == null) {
            throw new runtime.RequiredError(
                'sectionId',
                'Required parameter "sectionId" was null or undefined when calling deleteScriptSection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/sections/{sectionId}`.replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters['sectionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteScriptSection(requestParameters: DeleteScriptSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScriptSectionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteScriptStepRaw(requestParameters: DeleteScriptStepRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['stepId'] == null) {
            throw new runtime.RequiredError(
                'stepId',
                'Required parameter "stepId" was null or undefined when calling deleteScriptStep().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/steps/{stepId}`.replace(`{${"stepId"}}`, encodeURIComponent(String(requestParameters['stepId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteScriptStep(requestParameters: DeleteScriptStepRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScriptStepRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteScriptStepFieldRaw(requestParameters: DeleteScriptStepFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['stepId'] == null) {
            throw new runtime.RequiredError(
                'stepId',
                'Required parameter "stepId" was null or undefined when calling deleteScriptStepField().'
            );
        }

        if (requestParameters['fieldId'] == null) {
            throw new runtime.RequiredError(
                'fieldId',
                'Required parameter "fieldId" was null or undefined when calling deleteScriptStepField().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/steps/{stepId}/fields/{fieldId}`.replace(`{${"stepId"}}`, encodeURIComponent(String(requestParameters['stepId']))).replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteScriptStepField(requestParameters: DeleteScriptStepFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScriptStepFieldRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteScriptStepSentenceRaw(requestParameters: DeleteScriptStepSentenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['stepId'] == null) {
            throw new runtime.RequiredError(
                'stepId',
                'Required parameter "stepId" was null or undefined when calling deleteScriptStepSentence().'
            );
        }

        if (requestParameters['sentenceId'] == null) {
            throw new runtime.RequiredError(
                'sentenceId',
                'Required parameter "sentenceId" was null or undefined when calling deleteScriptStepSentence().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/steps/{stepId}/sentences/{sentenceId}`.replace(`{${"stepId"}}`, encodeURIComponent(String(requestParameters['stepId']))).replace(`{${"sentenceId"}}`, encodeURIComponent(String(requestParameters['sentenceId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteScriptStepSentence(requestParameters: DeleteScriptStepSentenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScriptStepSentenceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteSectionRaw(requestParameters: DeleteSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sectionId'] == null) {
            throw new runtime.RequiredError(
                'sectionId',
                'Required parameter "sectionId" was null or undefined when calling deleteSection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/sections/{sectionId}`.replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters['sectionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteSection(requestParameters: DeleteSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSectionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteTaskRaw(requestParameters: DeleteTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling deleteTask().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/tasks/{taskId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters['taskId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTask(requestParameters: DeleteTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTaskRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteTeamRaw(requestParameters: DeleteTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling deleteTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/teams/{teamId}`.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTeam(requestParameters: DeleteTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTeamRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling deleteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async demoCompareSentencesRaw(requestParameters: DemoCompareSentencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Array<number>>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/demo/compare-sentences`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async demoCompareSentences(requestParameters: DemoCompareSentencesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Array<number>>> {
        const response = await this.demoCompareSentencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async enableScriptLoggingRaw(requestParameters: EnableScriptLoggingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['scriptId'] == null) {
            throw new runtime.RequiredError(
                'scriptId',
                'Required parameter "scriptId" was null or undefined when calling enableScriptLogging().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scripts/{scriptId}/logging`.replace(`{${"scriptId"}}`, encodeURIComponent(String(requestParameters['scriptId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async enableScriptLogging(requestParameters: EnableScriptLoggingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.enableScriptLoggingRaw(requestParameters, initOverrides);
    }

    /**
     */
    async evaulateScorecardRaw(requestParameters: EvaulateScorecardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['scorecardId'] == null) {
            throw new runtime.RequiredError(
                'scorecardId',
                'Required parameter "scorecardId" was null or undefined when calling evaulateScorecard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/{scorecardId}/evaluations`.replace(`{${"scorecardId"}}`, encodeURIComponent(String(requestParameters['scorecardId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async evaulateScorecard(requestParameters: EvaulateScorecardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.evaulateScorecardRaw(requestParameters, initOverrides);
    }

    /**
     */
    async exportScorecardFeedbackRaw(requestParameters: ExportScorecardFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['filterDateMin'] != null) {
            queryParameters['filterDateMin'] = (requestParameters['filterDateMin'] as any).toISOString();
        }

        if (requestParameters['filterDateMax'] != null) {
            queryParameters['filterDateMax'] = (requestParameters['filterDateMax'] as any).toISOString();
        }

        if (requestParameters['desc'] != null) {
            queryParameters['desc'] = requestParameters['desc'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/feedback/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async exportScorecardFeedback(requestParameters: ExportScorecardFeedbackRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.exportScorecardFeedbackRaw(requestParameters, initOverrides);
    }

    /**
     */
    async extCreateManualQARaw(requestParameters: ExtCreateManualQARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetScorecardResultResponse>> {
        if (requestParameters['scorecardId'] == null) {
            throw new runtime.RequiredError(
                'scorecardId',
                'Required parameter "scorecardId" was null or undefined when calling extCreateManualQA().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/{scorecardId}/result`.replace(`{${"scorecardId"}}`, encodeURIComponent(String(requestParameters['scorecardId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateManualQARequestToJSON(requestParameters['createManualQARequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetScorecardResultResponseFromJSON(jsonValue));
    }

    /**
     */
    async extCreateManualQA(requestParameters: ExtCreateManualQARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetScorecardResultResponse> {
        const response = await this.extCreateManualQARaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async extGetContactAudioUriRaw(requestParameters: ExtGetContactAudioUriRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling extGetContactAudioUri().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/ext/contacts/{contactId}/audio-uri`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async extGetContactAudioUri(requestParameters: ExtGetContactAudioUriRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.extGetContactAudioUriRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async extractSentencesRaw(requestParameters: ExtractSentencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExtractionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/sentences/extract`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExtractSentenceRequestToJSON(requestParameters['extractSentenceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExtractionResponseFromJSON(jsonValue));
    }

    /**
     */
    async extractSentences(requestParameters: ExtractSentencesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExtractionResponse> {
        const response = await this.extractSentencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllScorecardFeedbacksRaw(requestParameters: GetAllScorecardFeedbacksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllScorecardFeedbacksResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['filterDateMin'] != null) {
            queryParameters['filterDateMin'] = (requestParameters['filterDateMin'] as any).toISOString();
        }

        if (requestParameters['filterDateMax'] != null) {
            queryParameters['filterDateMax'] = (requestParameters['filterDateMax'] as any).toISOString();
        }

        if (requestParameters['desc'] != null) {
            queryParameters['desc'] = requestParameters['desc'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/feedback`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllScorecardFeedbacksResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAllScorecardFeedbacks(requestParameters: GetAllScorecardFeedbacksRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllScorecardFeedbacksResponse> {
        const response = await this.getAllScorecardFeedbacksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAnalyticsSummaryRaw(requestParameters: GetAnalyticsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnalyticsSummaryEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/analytics/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnalyticsSummaryEntityFromJSON(jsonValue));
    }

    /**
     */
    async getAnalyticsSummary(requestParameters: GetAnalyticsSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnalyticsSummaryEntity> {
        const response = await this.getAnalyticsSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getApiKeysRaw(requestParameters: GetApiKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetApiKeysResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/api-keys`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetApiKeysResponseFromJSON(jsonValue));
    }

    /**
     */
    async getApiKeys(requestParameters: GetApiKeysRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetApiKeysResponse> {
        const response = await this.getApiKeysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated
     */
    async getCallControlsConfigRaw(requestParameters: GetCallControlsConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CallControlsConfig>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/call_controls_config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CallControlsConfigFromJSON(jsonValue));
    }

    /**
     * @deprecated
     */
    async getCallControlsConfig(requestParameters: GetCallControlsConfigRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CallControlsConfig> {
        const response = await this.getCallControlsConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getConfigRaw(requestParameters: GetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantConfig>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantConfigFromJSON(jsonValue));
    }

    /**
     */
    async getConfig(requestParameters: GetConfigRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantConfig> {
        const response = await this.getConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactRaw(requestParameters: GetContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Contact>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling getContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactFromJSON(jsonValue));
    }

    /**
     */
    async getContact(requestParameters: GetContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Contact> {
        const response = await this.getContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactBySourceIdRaw(requestParameters: GetContactBySourceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Contact>> {
        if (requestParameters['sourceId'] == null) {
            throw new runtime.RequiredError(
                'sourceId',
                'Required parameter "sourceId" was null or undefined when calling getContactBySourceId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/source-id/{sourceId}`.replace(`{${"sourceId"}}`, encodeURIComponent(String(requestParameters['sourceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactFromJSON(jsonValue));
    }

    /**
     */
    async getContactBySourceId(requestParameters: GetContactBySourceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Contact> {
        const response = await this.getContactBySourceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactEventsRaw(requestParameters: GetContactEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContactEventEntity>>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling getContactEvents().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/events`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContactEventEntityFromJSON));
    }

    /**
     */
    async getContactEvents(requestParameters: GetContactEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContactEventEntity>> {
        const response = await this.getContactEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactFieldsRaw(requestParameters: GetContactFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Field>>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling getContactFields().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/fields`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FieldFromJSON));
    }

    /**
     */
    async getContactFields(requestParameters: GetContactFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Field>> {
        const response = await this.getContactFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactGuidanceRaw(requestParameters: GetContactGuidanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Guidance>>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling getContactGuidance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/guidance`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GuidanceFromJSON));
    }

    /**
     */
    async getContactGuidance(requestParameters: GetContactGuidanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Guidance>> {
        const response = await this.getContactGuidanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactProductRecommendationsRaw(requestParameters: GetContactProductRecommendationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling getContactProductRecommendations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/products/recommendations`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getContactProductRecommendations(requestParameters: GetContactProductRecommendationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getContactProductRecommendationsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getContactScriptRaw(requestParameters: GetContactScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContactScriptResponse>> {
        if (requestParameters['scriptId'] == null) {
            throw new runtime.RequiredError(
                'scriptId',
                'Required parameter "scriptId" was null or undefined when calling getContactScript().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/script/{scriptId}`.replace(`{${"scriptId"}}`, encodeURIComponent(String(requestParameters['scriptId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContactScriptResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContactScript(requestParameters: GetContactScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContactScriptResponse> {
        const response = await this.getContactScriptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactScriptsRaw(requestParameters: GetContactScriptsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContactScriptsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scripts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContactScriptsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContactScripts(requestParameters: GetContactScriptsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContactScriptsResponse> {
        const response = await this.getContactScriptsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactScriptsTypeDefinitionsRaw(requestParameters: GetContactScriptsTypeDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scripts/contact.d.ts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getContactScriptsTypeDefinitions(requestParameters: GetContactScriptsTypeDefinitionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getContactScriptsTypeDefinitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactSuggestionsRaw(requestParameters: GetContactSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Suggestion>>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling getContactSuggestions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/suggestions`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SuggestionFromJSON));
    }

    /**
     */
    async getContactSuggestions(requestParameters: GetContactSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Suggestion>> {
        const response = await this.getContactSuggestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactTranscriptSummaryRaw(requestParameters: GetContactTranscriptSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContactTranscriptSummaryResponse>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling getContactTranscriptSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/transcript_summary`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContactTranscriptSummaryResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContactTranscriptSummary(requestParameters: GetContactTranscriptSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContactTranscriptSummaryResponse> {
        const response = await this.getContactTranscriptSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactUtterancesRaw(requestParameters: GetContactUtterancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Utterance>>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling getContactUtterances().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/utterances`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UtteranceFromJSON));
    }

    /**
     */
    async getContactUtterances(requestParameters: GetContactUtterancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Utterance>> {
        const response = await this.getContactUtterancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated
     */
    async getContactsRaw(requestParameters: GetContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContactSummary>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContactSummaryFromJSON));
    }

    /**
     * @deprecated
     */
    async getContacts(requestParameters: GetContactsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContactSummary>> {
        const response = await this.getContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactsStatsRaw(requestParameters: GetContactsStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContactsStatsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['users'] != null) {
            queryParameters['users'] = requestParameters['users'];
        }

        if (requestParameters['teams'] != null) {
            queryParameters['teams'] = requestParameters['teams'];
        }

        if (requestParameters['filterDateMin'] != null) {
            queryParameters['filterDateMin'] = (requestParameters['filterDateMin'] as any).toISOString();
        }

        if (requestParameters['filterDateMax'] != null) {
            queryParameters['filterDateMax'] = (requestParameters['filterDateMax'] as any).toISOString();
        }

        if (requestParameters['filterPhoneNumber'] != null) {
            queryParameters['filterPhoneNumber'] = requestParameters['filterPhoneNumber'];
        }

        if (requestParameters['filterScoreMin'] != null) {
            queryParameters['filterScoreMin'] = requestParameters['filterScoreMin'];
        }

        if (requestParameters['filterScoreMax'] != null) {
            queryParameters['filterScoreMax'] = requestParameters['filterScoreMax'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContactsStatsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContactsStats(requestParameters: GetContactsStatsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContactsStatsResponse> {
        const response = await this.getContactsStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactsTimeseriesRaw(requestParameters: GetContactsTimeseriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContactsTimeseriesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['filterDateMin'] != null) {
            queryParameters['filterDateMin'] = (requestParameters['filterDateMin'] as any).toISOString();
        }

        if (requestParameters['filterDateMax'] != null) {
            queryParameters['filterDateMax'] = (requestParameters['filterDateMax'] as any).toISOString();
        }

        if (requestParameters['interval'] != null) {
            queryParameters['interval'] = requestParameters['interval'];
        }

        if (requestParameters['teams'] != null) {
            queryParameters['teams'] = requestParameters['teams'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/timeseries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContactsTimeseriesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContactsTimeseries(requestParameters: GetContactsTimeseriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContactsTimeseriesResponse> {
        const response = await this.getContactsTimeseriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContactsV2Raw(requestParameters: GetContactsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContactsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['users'] != null) {
            queryParameters['users'] = requestParameters['users'];
        }

        if (requestParameters['teams'] != null) {
            queryParameters['teams'] = requestParameters['teams'];
        }

        if (requestParameters['filterDateMin'] != null) {
            queryParameters['filterDateMin'] = (requestParameters['filterDateMin'] as any).toISOString();
        }

        if (requestParameters['filterDateMax'] != null) {
            queryParameters['filterDateMax'] = (requestParameters['filterDateMax'] as any).toISOString();
        }

        if (requestParameters['filterPhoneNumber'] != null) {
            queryParameters['filterPhoneNumber'] = requestParameters['filterPhoneNumber'];
        }

        if (requestParameters['filterScoreMin'] != null) {
            queryParameters['filterScoreMin'] = requestParameters['filterScoreMin'];
        }

        if (requestParameters['filterScoreMax'] != null) {
            queryParameters['filterScoreMax'] = requestParameters['filterScoreMax'];
        }

        if (requestParameters['desc'] != null) {
            queryParameters['desc'] = requestParameters['desc'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contactsv2`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContactsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getContactsV2(requestParameters: GetContactsV2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContactsResponse> {
        const response = await this.getContactsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCrmIntegrationRaw(requestParameters: GetCrmIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmIntegrationResponse>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling getCrmIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/integrations/crm/{integrationId}`.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmIntegrationResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCrmIntegration(requestParameters: GetCrmIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmIntegrationResponse> {
        const response = await this.getCrmIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCrmIntegrationsRaw(requestParameters: GetCrmIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmIntegrationsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/integrations/crm`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmIntegrationsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCrmIntegrations(requestParameters: GetCrmIntegrationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmIntegrationsResponse> {
        const response = await this.getCrmIntegrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCurrentUserRaw(requestParameters: GetCurrentUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/users/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     */
    async getCurrentUser(requestParameters: GetCurrentUserRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.getCurrentUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerDetailsRaw(requestParameters: GetCustomerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerDetails>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCustomerDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customers/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerDetailsFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerDetails(requestParameters: GetCustomerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerDetails> {
        const response = await this.getCustomerDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerEntriesRaw(requestParameters: GetCustomerEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContactFieldsResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCustomerEntries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customers/{customerId}/entries`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContactFieldsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerEntries(requestParameters: GetCustomerEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContactFieldsResponse> {
        const response = await this.getCustomerEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerFieldsRaw(requestParameters: GetCustomerFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Field>>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCustomerFields().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customers/{customerId}/fields`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FieldFromJSON));
    }

    /**
     */
    async getCustomerFields(requestParameters: GetCustomerFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Field>> {
        const response = await this.getCustomerFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerOrdersRaw(requestParameters: GetCustomerOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrdersResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCustomerOrders().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customers/{customerId}/orders`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrdersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerOrders(requestParameters: GetCustomerOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrdersResponse> {
        const response = await this.getCustomerOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerPreviewRaw(requestParameters: GetCustomerPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomerPreviewResponse>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling getCustomerPreview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['contactId'] != null) {
            queryParameters['contactId'] = requestParameters['contactId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customers/preview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerPreviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerPreview(requestParameters: GetCustomerPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomerPreviewResponse> {
        const response = await this.getCustomerPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated
     */
    async getCustomerStatusesRaw(requestParameters: GetCustomerStatusesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerStatus>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/statuses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerStatusFromJSON));
    }

    /**
     * @deprecated
     */
    async getCustomerStatuses(requestParameters: GetCustomerStatusesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerStatus>> {
        const response = await this.getCustomerStatusesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDemoConvSignedUrlRaw(requestParameters: GetDemoConvSignedUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDemoConvSignedUrlResponse>> {
        const queryParameters: any = {};

        if (requestParameters['agentId'] != null) {
            queryParameters['agentId'] = requestParameters['agentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/demo/live-assist/conv-signed-url`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDemoConvSignedUrlResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDemoConvSignedUrl(requestParameters: GetDemoConvSignedUrlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDemoConvSignedUrlResponse> {
        const response = await this.getDemoConvSignedUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getExternalServiceRaw(requestParameters: GetExternalServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalServiceResponse>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling getExternalService().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/external-services/{serviceId}`.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalServiceResponseFromJSON(jsonValue));
    }

    /**
     */
    async getExternalService(requestParameters: GetExternalServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalServiceResponse> {
        const response = await this.getExternalServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getExternalServicesRaw(requestParameters: GetExternalServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalServicesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/external-services`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalServicesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getExternalServices(requestParameters: GetExternalServicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalServicesResponse> {
        const response = await this.getExternalServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getExtractorsRaw(requestParameters: GetExtractorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/extractors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getExtractors(requestParameters: GetExtractorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getExtractorsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getFieldGeneratorsRaw(requestParameters: GetFieldGeneratorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fieldId'] == null) {
            throw new runtime.RequiredError(
                'fieldId',
                'Required parameter "fieldId" was null or undefined when calling getFieldGenerators().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/fields/{fieldId}/generators`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getFieldGenerators(requestParameters: GetFieldGeneratorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getFieldGeneratorsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getFieldsRaw(requestParameters: GetFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FieldsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/fields`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FieldsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getFields(requestParameters: GetFieldsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FieldsResponse> {
        const response = await this.getFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGeneratorsRaw(requestParameters: GetGeneratorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/generators`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getGenerators(requestParameters: GetGeneratorsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getGeneratorsRaw(requestParameters, initOverrides);
    }

    /**
     * @deprecated
     */
    async getGlobalTenantConfigRaw(requestParameters: GetGlobalTenantConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantConfigEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/global_config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantConfigEntityFromJSON(jsonValue));
    }

    /**
     * @deprecated
     */
    async getGlobalTenantConfig(requestParameters: GetGlobalTenantConfigRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantConfigEntity> {
        const response = await this.getGlobalTenantConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLeaderboardRaw(requestParameters: GetLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LeaderboardEntryEntity>>> {
        const queryParameters: any = {};

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = (requestParameters['startTime'] as any).toISOString();
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = (requestParameters['endTime'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/leaderboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LeaderboardEntryEntityFromJSON));
    }

    /**
     */
    async getLeaderboard(requestParameters: GetLeaderboardRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LeaderboardEntryEntity>> {
        const response = await this.getLeaderboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrderRaw(requestParameters: GetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrderResponse>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling getOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/orders/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrderResponseFromJSON(jsonValue));
    }

    /**
     */
    async getOrder(requestParameters: GetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrderResponse> {
        const response = await this.getOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated
     */
    async getProductCatalogConfigRaw(requestParameters: GetProductCatalogConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductCatalogConfig>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/product_catalog_config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductCatalogConfigFromJSON(jsonValue));
    }

    /**
     * @deprecated
     */
    async getProductCatalogConfig(requestParameters: GetProductCatalogConfigRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductCatalogConfig> {
        const response = await this.getProductCatalogConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProductListPreviewRaw(requestParameters: GetProductListPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetProductListPreviewResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/products/preview-list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetProductListPreviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async getProductListPreview(requestParameters: GetProductListPreviewRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetProductListPreviewResponse> {
        const response = await this.getProductListPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReviewManagerScorecardStatsRaw(requestParameters: GetReviewManagerScorecardStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReviewerScorecardStatsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['filterDateMin'] != null) {
            queryParameters['filterDateMin'] = (requestParameters['filterDateMin'] as any).toISOString();
        }

        if (requestParameters['filterDateMax'] != null) {
            queryParameters['filterDateMax'] = (requestParameters['filterDateMax'] as any).toISOString();
        }

        if (requestParameters['interval'] != null) {
            queryParameters['interval'] = requestParameters['interval'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/manager-stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReviewerScorecardStatsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReviewManagerScorecardStats(requestParameters: GetReviewManagerScorecardStatsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReviewerScorecardStatsResponse> {
        const response = await this.getReviewManagerScorecardStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReviewerScorecardStatsRaw(requestParameters: GetReviewerScorecardStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReviewerScorecardStatsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['filterDateMin'] != null) {
            queryParameters['filterDateMin'] = (requestParameters['filterDateMin'] as any).toISOString();
        }

        if (requestParameters['filterDateMax'] != null) {
            queryParameters['filterDateMax'] = (requestParameters['filterDateMax'] as any).toISOString();
        }

        if (requestParameters['interval'] != null) {
            queryParameters['interval'] = requestParameters['interval'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/reviewer-stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReviewerScorecardStatsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReviewerScorecardStats(requestParameters: GetReviewerScorecardStatsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReviewerScorecardStatsResponse> {
        const response = await this.getReviewerScorecardStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getScorecardRaw(requestParameters: GetScorecardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetScorecardResultResponse>> {
        if (requestParameters['scorecardId'] == null) {
            throw new runtime.RequiredError(
                'scorecardId',
                'Required parameter "scorecardId" was null or undefined when calling getScorecard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/{scorecardId}/result`.replace(`{${"scorecardId"}}`, encodeURIComponent(String(requestParameters['scorecardId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetScorecardResultResponseFromJSON(jsonValue));
    }

    /**
     */
    async getScorecard(requestParameters: GetScorecardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetScorecardResultResponse> {
        const response = await this.getScorecardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getScorecardFeedbacksRaw(requestParameters: GetScorecardFeedbacksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetScorecardFeedbacksResponse>> {
        if (requestParameters['scorecardId'] == null) {
            throw new runtime.RequiredError(
                'scorecardId',
                'Required parameter "scorecardId" was null or undefined when calling getScorecardFeedbacks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/{scorecardId}/feedback`.replace(`{${"scorecardId"}}`, encodeURIComponent(String(requestParameters['scorecardId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetScorecardFeedbacksResponseFromJSON(jsonValue));
    }

    /**
     */
    async getScorecardFeedbacks(requestParameters: GetScorecardFeedbacksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetScorecardFeedbacksResponse> {
        const response = await this.getScorecardFeedbacksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getScorecardRuleScriptTypesRaw(requestParameters: GetScorecardRuleScriptTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecard-rule-scripts/typed.d.ts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getScorecardRuleScriptTypes(requestParameters: GetScorecardRuleScriptTypesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getScorecardRuleScriptTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getScorecardTemplateRaw(requestParameters: GetScorecardTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScorecardTemplateSingleResponse>> {
        if (requestParameters['scorecardTemplateId'] == null) {
            throw new runtime.RequiredError(
                'scorecardTemplateId',
                'Required parameter "scorecardTemplateId" was null or undefined when calling getScorecardTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecard-templates/{scorecardTemplateId}`.replace(`{${"scorecardTemplateId"}}`, encodeURIComponent(String(requestParameters['scorecardTemplateId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScorecardTemplateSingleResponseFromJSON(jsonValue));
    }

    /**
     */
    async getScorecardTemplate(requestParameters: GetScorecardTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScorecardTemplateSingleResponse> {
        const response = await this.getScorecardTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getScriptRaw(requestParameters: GetScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScriptResponse>> {
        if (requestParameters['scriptId'] == null) {
            throw new runtime.RequiredError(
                'scriptId',
                'Required parameter "scriptId" was null or undefined when calling getScript().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/{scriptId}`.replace(`{${"scriptId"}}`, encodeURIComponent(String(requestParameters['scriptId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScriptResponseFromJSON(jsonValue));
    }

    /**
     */
    async getScript(requestParameters: GetScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScriptResponse> {
        const response = await this.getScriptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getScriptLogsRaw(requestParameters: GetScriptLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetScriptLogsResponse>> {
        if (requestParameters['scriptId'] == null) {
            throw new runtime.RequiredError(
                'scriptId',
                'Required parameter "scriptId" was null or undefined when calling getScriptLogs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scripts/{scriptId}/logs`.replace(`{${"scriptId"}}`, encodeURIComponent(String(requestParameters['scriptId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetScriptLogsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getScriptLogs(requestParameters: GetScriptLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetScriptLogsResponse> {
        const response = await this.getScriptLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getScriptsRaw(requestParameters: GetScriptsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScriptsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScriptsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getScripts(requestParameters: GetScriptsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScriptsResponse> {
        const response = await this.getScriptsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSectionRaw(requestParameters: GetSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SectionSingleResponse>> {
        if (requestParameters['sectionId'] == null) {
            throw new runtime.RequiredError(
                'sectionId',
                'Required parameter "sectionId" was null or undefined when calling getSection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/sections/{sectionId}`.replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters['sectionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SectionSingleResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSection(requestParameters: GetSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SectionSingleResponse> {
        const response = await this.getSectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSentencesRaw(requestParameters: GetSentencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SentenceEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/sentences`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SentenceEntityFromJSON));
    }

    /**
     */
    async getSentences(requestParameters: GetSentencesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SentenceEntity>> {
        const response = await this.getSentencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTaskRaw(requestParameters: GetTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleTaskResponse>> {
        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling getTask().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/tasks/{taskId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters['taskId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SingleTaskResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTask(requestParameters: GetTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleTaskResponse> {
        const response = await this.getTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTaskSuggestionRaw(requestParameters: GetTaskSuggestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleTaskSuggestionResponse>> {
        if (requestParameters['taskSuggestionId'] == null) {
            throw new runtime.RequiredError(
                'taskSuggestionId',
                'Required parameter "taskSuggestionId" was null or undefined when calling getTaskSuggestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/task-suggestions/{taskSuggestionId}`.replace(`{${"taskSuggestionId"}}`, encodeURIComponent(String(requestParameters['taskSuggestionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SingleTaskSuggestionResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTaskSuggestion(requestParameters: GetTaskSuggestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleTaskSuggestionResponse> {
        const response = await this.getTaskSuggestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTeamRaw(requestParameters: GetTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTeamResponse>> {
        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling getTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/teams/{teamId}`.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTeamResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTeam(requestParameters: GetTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTeamResponse> {
        const response = await this.getTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTeamUsersRaw(requestParameters: GetTeamUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTeamUsersResponse>> {
        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling getTeamUsers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/teams/{teamId}/users`.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTeamUsersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTeamUsers(requestParameters: GetTeamUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTeamUsersResponse> {
        const response = await this.getTeamUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTeamsRaw(requestParameters: GetTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTeamsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/teams`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTeamsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTeams(requestParameters: GetTeamsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTeamsResponse> {
        const response = await this.getTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTenantContactEventsRaw(requestParameters: GetTenantContactEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTenantContactEventsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/contact_events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTenantContactEventsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTenantContactEvents(requestParameters: GetTenantContactEventsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTenantContactEventsResponse> {
        const response = await this.getTenantContactEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTenantsRaw(requestParameters: GetTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTenantsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/tenants`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTenantsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTenants(requestParameters: GetTenantsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTenantsResponse> {
        const response = await this.getTenantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserResponse> {
        const response = await this.getUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUserOrdersRaw(requestParameters: GetUserOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrdersResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserOrders().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/users/{userId}/orders`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrdersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUserOrders(requestParameters: GetUserOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrdersResponse> {
        const response = await this.getUserOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUserTaskSuggestionsRaw(requestParameters: GetUserTaskSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskSuggestionsListResponse>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling getUserTaskSuggestions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/task-suggestions`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskSuggestionsListResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUserTaskSuggestions(requestParameters: GetUserTaskSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskSuggestionsListResponse> {
        const response = await this.getUserTaskSuggestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUserTasksRaw(requestParameters: GetUserTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TasksListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/tasks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TasksListResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUserTasks(requestParameters: GetUserTasksRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TasksListResponse> {
        const response = await this.getUserTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUsersRaw(requestParameters: GetUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUsersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUsers(requestParameters: GetUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsersResponse> {
        const response = await this.getUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async importScorecardRaw(requestParameters: ImportScorecardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards-templates/imports`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScorecardTemplateToJSON(requestParameters['scorecardTemplate']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importScorecard(requestParameters: ImportScorecardRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importScorecardRaw(requestParameters, initOverrides);
    }

    /**
     */
    async listAgentsRaw(requestParameters: ListAgentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAgentsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/agents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAgentsResponseFromJSON(jsonValue));
    }

    /**
     */
    async listAgents(requestParameters: ListAgentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAgentsResponse> {
        const response = await this.listAgentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listHooksRaw(requestParameters: ListHooksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListHooksResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/hooks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListHooksResponseFromJSON(jsonValue));
    }

    /**
     */
    async listHooks(requestParameters: ListHooksRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListHooksResponse> {
        const response = await this.listHooksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listScorecardContactsRaw(requestParameters: ListScorecardContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListScorecardContactsResponse>> {
        if (requestParameters['scorecardId'] == null) {
            throw new runtime.RequiredError(
                'scorecardId',
                'Required parameter "scorecardId" was null or undefined when calling listScorecardContacts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/{scorecardId}/contacts`.replace(`{${"scorecardId"}}`, encodeURIComponent(String(requestParameters['scorecardId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListScorecardContactsResponseFromJSON(jsonValue));
    }

    /**
     */
    async listScorecardContacts(requestParameters: ListScorecardContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListScorecardContactsResponse> {
        const response = await this.listScorecardContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listScorecardTemplatesRaw(requestParameters: ListScorecardTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScorecardTemplateSummaryListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecard-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScorecardTemplateSummaryListResponseFromJSON(jsonValue));
    }

    /**
     */
    async listScorecardTemplates(requestParameters: ListScorecardTemplatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScorecardTemplateSummaryListResponse> {
        const response = await this.listScorecardTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listScorecardsRaw(requestParameters: ListScorecardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListScorecardsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListScorecardsResponseFromJSON(jsonValue));
    }

    /**
     */
    async listScorecards(requestParameters: ListScorecardsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListScorecardsResponse> {
        const response = await this.listScorecardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listSectionsRaw(requestParameters: ListSectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SectionListResponse>> {
        if (requestParameters['scorecardTemplateId'] == null) {
            throw new runtime.RequiredError(
                'scorecardTemplateId',
                'Required parameter "scorecardTemplateId" was null or undefined when calling listSections().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecard-templates/{scorecardTemplateId}/sections`.replace(`{${"scorecardTemplateId"}}`, encodeURIComponent(String(requestParameters['scorecardTemplateId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SectionListResponseFromJSON(jsonValue));
    }

    /**
     */
    async listSections(requestParameters: ListSectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SectionListResponse> {
        const response = await this.listSectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mergeCustomerRecordsRaw(requestParameters: MergeCustomerRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveCustomerIdResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customers/merge`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MergeCustomerRecordsRequestToJSON(requestParameters['mergeCustomerRecordsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveCustomerIdResponseFromJSON(jsonValue));
    }

    /**
     */
    async mergeCustomerRecords(requestParameters: MergeCustomerRecordsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveCustomerIdResponse> {
        const response = await this.mergeCustomerRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mergeRejectSuggestionRaw(requestParameters: MergeRejectSuggestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customers/merge/suggestion/rejected`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RejectCustomerMergeRequestToJSON(requestParameters['rejectCustomerMergeRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mergeRejectSuggestion(requestParameters: MergeRejectSuggestionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mergeRejectSuggestionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async refreshSearchRaw(requestParameters: RefreshSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSearchResponse>> {
        if (requestParameters['searchId'] == null) {
            throw new runtime.RequiredError(
                'searchId',
                'Required parameter "searchId" was null or undefined when calling refreshSearch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/searches/{searchId}/refresh`.replace(`{${"searchId"}}`, encodeURIComponent(String(requestParameters['searchId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSearchResponseFromJSON(jsonValue));
    }

    /**
     */
    async refreshSearch(requestParameters: RefreshSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSearchResponse> {
        const response = await this.refreshSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async rejectTaskSuggestionRaw(requestParameters: RejectTaskSuggestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleTaskSuggestionResponse>> {
        if (requestParameters['taskSuggestionId'] == null) {
            throw new runtime.RequiredError(
                'taskSuggestionId',
                'Required parameter "taskSuggestionId" was null or undefined when calling rejectTaskSuggestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/task-suggestions/{taskSuggestionId}/rejections`.replace(`{${"taskSuggestionId"}}`, encodeURIComponent(String(requestParameters['taskSuggestionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SingleTaskSuggestionResponseFromJSON(jsonValue));
    }

    /**
     */
    async rejectTaskSuggestion(requestParameters: RejectTaskSuggestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleTaskSuggestionResponse> {
        const response = await this.rejectTaskSuggestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async removeGeneratorFromFieldRaw(requestParameters: RemoveGeneratorFromFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fieldId'] == null) {
            throw new runtime.RequiredError(
                'fieldId',
                'Required parameter "fieldId" was null or undefined when calling removeGeneratorFromField().'
            );
        }

        if (requestParameters['generatorId'] == null) {
            throw new runtime.RequiredError(
                'generatorId',
                'Required parameter "generatorId" was null or undefined when calling removeGeneratorFromField().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/fields/{fieldId}/generators/{generatorId}`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))).replace(`{${"generatorId"}}`, encodeURIComponent(String(requestParameters['generatorId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeGeneratorFromField(requestParameters: RemoveGeneratorFromFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeGeneratorFromFieldRaw(requestParameters, initOverrides);
    }

    /**
     */
    async removeTeamUserRaw(requestParameters: RemoveTeamUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling removeTeamUser().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling removeTeamUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/teams/{teamId}/users/{userId}`.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId']))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeTeamUser(requestParameters: RemoveTeamUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeTeamUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async reorderSectionRulesRaw(requestParameters: ReorderSectionRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sectionId'] == null) {
            throw new runtime.RequiredError(
                'sectionId',
                'Required parameter "sectionId" was null or undefined when calling reorderSectionRules().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/sections/{sectionId}/rules/order`.replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters['sectionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async reorderSectionRules(requestParameters: ReorderSectionRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reorderSectionRulesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async reorderSectionsRaw(requestParameters: ReorderSectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['scorecardTemplateId'] == null) {
            throw new runtime.RequiredError(
                'scorecardTemplateId',
                'Required parameter "scorecardTemplateId" was null or undefined when calling reorderSections().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecard-templates/{scorecardTemplateId}/sections/order`.replace(`{${"scorecardTemplateId"}}`, encodeURIComponent(String(requestParameters['scorecardTemplateId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async reorderSections(requestParameters: ReorderSectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reorderSectionsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async revokeApiKeyRaw(requestParameters: RevokeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RevokeApiKeyResponse>> {
        if (requestParameters['apiKeyId'] == null) {
            throw new runtime.RequiredError(
                'apiKeyId',
                'Required parameter "apiKeyId" was null or undefined when calling revokeApiKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/api-keys/{apiKeyId}`.replace(`{${"apiKeyId"}}`, encodeURIComponent(String(requestParameters['apiKeyId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RevokeApiKeyResponseFromJSON(jsonValue));
    }

    /**
     */
    async revokeApiKey(requestParameters: RevokeApiKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RevokeApiKeyResponse> {
        const response = await this.revokeApiKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchCustomersRaw(requestParameters: SearchCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomersListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderDesc'] != null) {
            queryParameters['orderDesc'] = requestParameters['orderDesc'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customers/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomersListResponseFromJSON(jsonValue));
    }

    /**
     */
    async searchCustomers(requestParameters: SearchCustomersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomersListResponse> {
        const response = await this.searchCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchScorecardSentenceRaw(requestParameters: SearchScorecardSentenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchScorecardSentenceResponse>> {
        if (requestParameters['scorecardId'] == null) {
            throw new runtime.RequiredError(
                'scorecardId',
                'Required parameter "scorecardId" was null or undefined when calling searchScorecardSentence().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sample'] != null) {
            queryParameters['sample'] = requestParameters['sample'];
        }

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/{scorecardId}/transcript-search`.replace(`{${"scorecardId"}}`, encodeURIComponent(String(requestParameters['scorecardId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchScorecardSentenceResponseFromJSON(jsonValue));
    }

    /**
     */
    async searchScorecardSentence(requestParameters: SearchScorecardSentenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchScorecardSentenceResponse> {
        const response = await this.searchScorecardSentenceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchSentencesRaw(requestParameters: SearchSentencesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchSentencesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/sentences/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchSentencesRequestToJSON(requestParameters['searchSentencesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSentencesResponseFromJSON(jsonValue));
    }

    /**
     */
    async searchSentences(requestParameters: SearchSentencesOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchSentencesResponse> {
        const response = await this.searchSentencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async smmarizeContactRaw(requestParameters: SmmarizeContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling smmarizeContact().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tier'] != null) {
            queryParameters['tier'] = requestParameters['tier'];
        }

        if (requestParameters['chunkSize'] != null) {
            queryParameters['chunkSize'] = requestParameters['chunkSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/summary`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async smmarizeContact(requestParameters: SmmarizeContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.smmarizeContactRaw(requestParameters, initOverrides);
    }

    /**
     */
    async testContactScriptRaw(requestParameters: TestContactScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['scriptId'] == null) {
            throw new runtime.RequiredError(
                'scriptId',
                'Required parameter "scriptId" was null or undefined when calling testContactScript().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scripts/{scriptId}/test`.replace(`{${"scriptId"}}`, encodeURIComponent(String(requestParameters['scriptId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async testContactScript(requestParameters: TestContactScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.testContactScriptRaw(requestParameters, initOverrides);
    }

    /**
     */
    async testCustomCrmIntegrationCreateCustomerRaw(requestParameters: TestCustomCrmIntegrationCreateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmIntegrationTestCreateCustomerResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/integrations/crm/test/create_customer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmIntegrationTestCreateCustomerResponseFromJSON(jsonValue));
    }

    /**
     */
    async testCustomCrmIntegrationCreateCustomer(requestParameters: TestCustomCrmIntegrationCreateCustomerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmIntegrationTestCreateCustomerResponse> {
        const response = await this.testCustomCrmIntegrationCreateCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testExternalServiceCreateCustomerRaw(requestParameters: TestExternalServiceCreateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling testExternalServiceCreateCustomer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/external-services/{serviceId}/test/create-customer`.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCustomerRequestToJSON(requestParameters['createCustomerRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async testExternalServiceCreateCustomer(requestParameters: TestExternalServiceCreateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.testExternalServiceCreateCustomerRaw(requestParameters, initOverrides);
    }

    /**
     */
    async testSearchRaw(requestParameters: TestSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestSearchResponse>> {
        const queryParameters: any = {};

        if (requestParameters['fieldId'] != null) {
            queryParameters['fieldId'] = requestParameters['fieldId'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/searches/test`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestSearchResponseFromJSON(jsonValue));
    }

    /**
     */
    async testSearch(requestParameters: TestSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestSearchResponse> {
        const response = await this.testSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async undoMergeCustomerRecordsRaw(requestParameters: UndoMergeCustomerRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customers/merge`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: UndoMergeCustomerRecordsRequestToJSON(requestParameters['undoMergeCustomerRecordsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async undoMergeCustomerRecords(requestParameters: UndoMergeCustomerRecordsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.undoMergeCustomerRecordsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateContactRoleMappingsRaw(requestParameters: UpdateContactRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['scorecardId'] == null) {
            throw new runtime.RequiredError(
                'scorecardId',
                'Required parameter "scorecardId" was null or undefined when calling updateContactRoleMappings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/{scorecardId}/contact-role-mappings`.replace(`{${"scorecardId"}}`, encodeURIComponent(String(requestParameters['scorecardId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateContactRoleMappingRequestToJSON(requestParameters['updateContactRoleMappingRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateContactRoleMappings(requestParameters: UpdateContactRoleMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateContactRoleMappingsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateContactScriptRaw(requestParameters: UpdateContactScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateContactScriptResponse>> {
        if (requestParameters['scriptId'] == null) {
            throw new runtime.RequiredError(
                'scriptId',
                'Required parameter "scriptId" was null or undefined when calling updateContactScript().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scripts/{scriptId}`.replace(`{${"scriptId"}}`, encodeURIComponent(String(requestParameters['scriptId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateContactScriptManifestRequestToJSON(requestParameters['updateContactScriptManifestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateContactScriptResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateContactScript(requestParameters: UpdateContactScriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateContactScriptResponse> {
        const response = await this.updateContactScriptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCrmIntegrationRaw(requestParameters: UpdateCrmIntegrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CrmIntegrationResponse>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling updateCrmIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/integrations/crm/{integrationId}`.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters['integrationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCrmIntegrationRequestToJSON(requestParameters['updateCrmIntegrationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CrmIntegrationResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateCrmIntegration(requestParameters: UpdateCrmIntegrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CrmIntegrationResponse> {
        const response = await this.updateCrmIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCustomerRaw(requestParameters: UpdateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updateCustomer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/customers/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCustomerDetailsRequestToJSON(requestParameters['updateCustomerDetailsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateCustomer(requestParameters: UpdateCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCustomerRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateExternalServiceRaw(requestParameters: UpdateExternalServiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalServiceResponse>> {
        if (requestParameters['serviceId'] == null) {
            throw new runtime.RequiredError(
                'serviceId',
                'Required parameter "serviceId" was null or undefined when calling updateExternalService().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/external-services/{serviceId}`.replace(`{${"serviceId"}}`, encodeURIComponent(String(requestParameters['serviceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateExternalServiceRequestToJSON(requestParameters['updateExternalServiceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalServiceResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateExternalService(requestParameters: UpdateExternalServiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalServiceResponse> {
        const response = await this.updateExternalServiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateExtractorRaw(requestParameters: UpdateExtractorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateExtractorRequest>> {
        if (requestParameters['extractorId'] == null) {
            throw new runtime.RequiredError(
                'extractorId',
                'Required parameter "extractorId" was null or undefined when calling updateExtractor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/extractors/{extractorId}`.replace(`{${"extractorId"}}`, encodeURIComponent(String(requestParameters['extractorId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateExtractorRequestToJSON(requestParameters['updateExtractorRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateExtractorRequestFromJSON(jsonValue));
    }

    /**
     */
    async updateExtractor(requestParameters: UpdateExtractorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateExtractorRequest> {
        const response = await this.updateExtractorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateFieldRaw(requestParameters: UpdateFieldOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateFieldRequest>> {
        if (requestParameters['fieldId'] == null) {
            throw new runtime.RequiredError(
                'fieldId',
                'Required parameter "fieldId" was null or undefined when calling updateField().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/fields/{fieldId}`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFieldRequestToJSON(requestParameters['updateFieldRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateFieldRequestFromJSON(jsonValue));
    }

    /**
     */
    async updateField(requestParameters: UpdateFieldOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateFieldRequest> {
        const response = await this.updateFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateGeneratorRaw(requestParameters: UpdateGeneratorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateGeneratorRequest>> {
        if (requestParameters['generatorId'] == null) {
            throw new runtime.RequiredError(
                'generatorId',
                'Required parameter "generatorId" was null or undefined when calling updateGenerator().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/generators/{generatorId}`.replace(`{${"generatorId"}}`, encodeURIComponent(String(requestParameters['generatorId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGeneratorRequestToJSON(requestParameters['updateGeneratorRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateGeneratorRequestFromJSON(jsonValue));
    }

    /**
     */
    async updateGenerator(requestParameters: UpdateGeneratorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateGeneratorRequest> {
        const response = await this.updateGeneratorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateGuidanceStatusRaw(requestParameters: UpdateGuidanceStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Guidance>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling updateGuidanceStatus().'
            );
        }

        if (requestParameters['guidanceId'] == null) {
            throw new runtime.RequiredError(
                'guidanceId',
                'Required parameter "guidanceId" was null or undefined when calling updateGuidanceStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/contacts/{contactId}/guidance/{guidanceId}/status`.replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))).replace(`{${"guidanceId"}}`, encodeURIComponent(String(requestParameters['guidanceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GuidanceFromJSON(jsonValue));
    }

    /**
     */
    async updateGuidanceStatus(requestParameters: UpdateGuidanceStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Guidance> {
        const response = await this.updateGuidanceStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateHookRaw(requestParameters: UpdateHookOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleHookResponse>> {
        if (requestParameters['hookId'] == null) {
            throw new runtime.RequiredError(
                'hookId',
                'Required parameter "hookId" was null or undefined when calling updateHook().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/hooks/{hookId}`.replace(`{${"hookId"}}`, encodeURIComponent(String(requestParameters['hookId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateHookRequestToJSON(requestParameters['updateHookRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SingleHookResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateHook(requestParameters: UpdateHookOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleHookResponse> {
        const response = await this.updateHookRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateRuleRaw(requestParameters: UpdateRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RuleSingleResponse>> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling updateRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/rules/{ruleId}`.replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters['ruleId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRuleRequestToJSON(requestParameters['updateRuleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RuleSingleResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateRule(requestParameters: UpdateRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RuleSingleResponse> {
        const response = await this.updateRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateScorecardRaw(requestParameters: UpdateScorecardOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetScorecardResponse>> {
        if (requestParameters['scorecardId'] == null) {
            throw new runtime.RequiredError(
                'scorecardId',
                'Required parameter "scorecardId" was null or undefined when calling updateScorecard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecards/{scorecardId}`.replace(`{${"scorecardId"}}`, encodeURIComponent(String(requestParameters['scorecardId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScorecardRequestToJSON(requestParameters['updateScorecardRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetScorecardResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateScorecard(requestParameters: UpdateScorecardOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetScorecardResponse> {
        const response = await this.updateScorecardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateScorecardRulesOrderRaw(requestParameters: UpdateScorecardRulesOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['scorecardTemplateId'] == null) {
            throw new runtime.RequiredError(
                'scorecardTemplateId',
                'Required parameter "scorecardTemplateId" was null or undefined when calling updateScorecardRulesOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecard-templates/{scorecardTemplateId}/rules/order`.replace(`{${"scorecardTemplateId"}}`, encodeURIComponent(String(requestParameters['scorecardTemplateId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateScorecardRulesOrder(requestParameters: UpdateScorecardRulesOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateScorecardRulesOrderRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateScorecardTemplateRaw(requestParameters: UpdateScorecardTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScorecardTemplateSingleResponse>> {
        if (requestParameters['scorecardTemplateId'] == null) {
            throw new runtime.RequiredError(
                'scorecardTemplateId',
                'Required parameter "scorecardTemplateId" was null or undefined when calling updateScorecardTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/scorecard-templates/{scorecardTemplateId}`.replace(`{${"scorecardTemplateId"}}`, encodeURIComponent(String(requestParameters['scorecardTemplateId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScorecardTemplateRequestToJSON(requestParameters['updateScorecardTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScorecardTemplateSingleResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateScorecardTemplate(requestParameters: UpdateScorecardTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScorecardTemplateSingleResponse> {
        const response = await this.updateScorecardTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateScriptRaw(requestParameters: UpdateScriptOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScriptResponse>> {
        if (requestParameters['scriptId'] == null) {
            throw new runtime.RequiredError(
                'scriptId',
                'Required parameter "scriptId" was null or undefined when calling updateScript().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/{scriptId}`.replace(`{${"scriptId"}}`, encodeURIComponent(String(requestParameters['scriptId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScriptRequestToJSON(requestParameters['updateScriptRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScriptResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateScript(requestParameters: UpdateScriptOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScriptResponse> {
        const response = await this.updateScriptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateScriptSectionRaw(requestParameters: UpdateScriptSectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScriptSectionResponse>> {
        if (requestParameters['sectionId'] == null) {
            throw new runtime.RequiredError(
                'sectionId',
                'Required parameter "sectionId" was null or undefined when calling updateScriptSection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/sections/{sectionId}`.replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters['sectionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScriptSectionRequestToJSON(requestParameters['updateScriptSectionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScriptSectionResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateScriptSection(requestParameters: UpdateScriptSectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScriptSectionResponse> {
        const response = await this.updateScriptSectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateScriptStepRaw(requestParameters: UpdateScriptStepOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScriptStepResponse>> {
        if (requestParameters['stepId'] == null) {
            throw new runtime.RequiredError(
                'stepId',
                'Required parameter "stepId" was null or undefined when calling updateScriptStep().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/config/scripts/steps/{stepId}`.replace(`{${"stepId"}}`, encodeURIComponent(String(requestParameters['stepId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScriptStepRequestToJSON(requestParameters['updateScriptStepRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScriptStepResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateScriptStep(requestParameters: UpdateScriptStepOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScriptStepResponse> {
        const response = await this.updateScriptStepRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateSectionRaw(requestParameters: UpdateSectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SectionSingleResponse>> {
        if (requestParameters['sectionId'] == null) {
            throw new runtime.RequiredError(
                'sectionId',
                'Required parameter "sectionId" was null or undefined when calling updateSection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/sections/{sectionId}`.replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters['sectionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSectionRequestToJSON(requestParameters['updateSectionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SectionSingleResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateSection(requestParameters: UpdateSectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SectionSingleResponse> {
        const response = await this.updateSectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateSuggestionRaw(requestParameters: UpdateSuggestionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['suggestionId'] == null) {
            throw new runtime.RequiredError(
                'suggestionId',
                'Required parameter "suggestionId" was null or undefined when calling updateSuggestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/suggestions/{suggestionId}`.replace(`{${"suggestionId"}}`, encodeURIComponent(String(requestParameters['suggestionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSuggestionRequestToJSON(requestParameters['updateSuggestionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateSuggestion(requestParameters: UpdateSuggestionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSuggestionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateTaskRaw(requestParameters: UpdateTaskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleTaskResponse>> {
        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling updateTask().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/tasks/{taskId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters['taskId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTaskRequestToJSON(requestParameters['updateTaskRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SingleTaskResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateTask(requestParameters: UpdateTaskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleTaskResponse> {
        const response = await this.updateTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateTeamRaw(requestParameters: UpdateTeamOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling updateTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/teams/{teamId}`.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTeamRequestToJSON(requestParameters['updateTeamRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateTeam(requestParameters: UpdateTeamOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTeamRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateTeamUserRaw(requestParameters: UpdateTeamUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling updateTeamUser().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateTeamUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/teams/{teamId}/users/{userId}`.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId']))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTeamUserRequestToJSON(requestParameters['updateTeamUserRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateTeamUser(requestParameters: UpdateTeamUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTeamUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateUserRaw(requestParameters: UpdateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantId'] != null) {
            headerParameters['X-Tenant-Id'] = String(requestParameters['xTenantId']);
        }

        if (requestParameters['xRole'] != null) {
            headerParameters['X-Role'] = String(requestParameters['xRole']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Api-Key"] = await this.configuration.apiKey("Api-Key"); // ApiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/app/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserRequestToJSON(requestParameters['updateUserRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateUser(requestParameters: UpdateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserRaw(requestParameters, initOverrides);
    }

}
